// Marathi language file
export const MR = {
  preparing_zip: "झिप तयार करत आहे…",
  compressing: "संकुचित करत आहे…",
  info_icon: "एकदा पूर्ण म्हणून चिन्हांकित केल्यानंतर, कोणतेही अतिरिक्त सदस्य सामील होऊ शकत नाहीत किंवा जोडले जाऊ शकत नाहीत, आणि सर्व चॅट ग्रुप निष्क्रिय केले जातील. कृपया लक्षात घ्या की प्रकल्प, सर्व चॅट ग्रुप आणि डेटासह, निष्क्रिय स्थितीत प्रवेशयोग्य राहील.",
  mark_is_done: "तुम्हाला खात्री आहे की तुम्ही प्रकल्प पूर्ण म्हणून चिन्हांकित करू इच्छिता? एकदा चिन्हांकित केल्यानंतर, कोणतेही अतिरिक्त सदस्य सामील होऊ शकत नाहीत किंवा जोडले जाऊ शकत नाहीत, आणि सर्व चॅट ग्रुप निष्क्रिय केले जातील. कृपया लक्षात घ्या की प्रकल्प, सर्व चॅट ग्रुप आणि डेटासह, निष्क्रिय स्थितीत प्रवेशयोग्य राहील.",
  mark_not_done: "तुम्हाला खात्री आहे की तुम्ही प्रकल्प पुन्हा उघडू इच्छिता? एकदा उघडा म्हणून चिन्हांकित केल्यानंतर, अतिरिक्त सदस्य सामील होऊ शकतात किंवा जोडले जाऊ शकतात, आणि सर्व चॅट ग्रुप पुन्हा सक्रिय केले जातील.",
  mark_as_completed: "प्रकल्प पूर्ण म्हणून चिन्हांकित करा",
  room_completed: "प्रकल्प पूर्ण झाला",
  room_members: "प्रकल्पाचे सदस्य",
  deactivated_rooms: "निष्क्रिय प्रकल्प",
  deactivated_chats: "निष्क्रिय चॅट",
  completed_rooms: "पूर्ण झालेले प्रकल्प",
  request_to_join_a_room: 'प्रकल्पात सामील होण्याची विनंती',
  wants_to_rejoin_room: 'Username Roomname प्रकल्पात पुन्हा सामील होऊ इच्छितात.',
  invited_you_to_join_room: 'Username ने तुम्हाला Roomname प्रकल्पात सामील होण्यासाठी आमंत्रित केले आहे.',
  restart: "पुन्हा सुरू करा",
  update_text: "नवीन अद्यतन उपलब्ध आहे. अद्यतन स्थापित करण्यासाठी पुन्हा सुरू करा वर क्लिक करा.",
  update_availble: "अद्यतन उपलब्ध",
  Loading: "लोड होत आहे...",
  logout: "लॉगआउट",
  back: 'मागे',
  company_list: "कंपनी यादी",
  followers: "अनुसरणकर्ते",
  followings: "अनुसरण करीत आहे",
  article: "लेख",
  companies: "कंपन्या",
  one_to_one_chat: " एक ते एक चॅट",
  profile: "प्रोफाइल",
  company: "कंपनी",
  company_selection: "कंपनी निवड",
  home: "मुख्यपृष्ठ",
  contact: "संपर्क ",
  add_company: "कंपनी जोडा ",
  add_project: "प्रकल्प जोडा ",
  capacities: "क्षमता ",
  work_area: "कामाचे क्षेत्र",
  company_services: "कंपनी सेवा",
  website: "वेबसाइट",
  search_contacts: "संपर्क शोधा",
  add_or_join_a_company: "कंपनी जोडा किंवा सामील व्हा",
  follow: "अनुसरण करा",
  following: "अनुसरण करीत आहे",
  like: "आवड",
  company_contacts: "कंपनी संपर्क",
  leave_the_company: "कंपनी सोडा",
  news: "बातम्या",
  earlier: "पूर्वी",
  action: "क्रिया",
  another_action: "दुसरी क्रिया",
  something_else: "काहीतरी वेगळे",
  search: "शोधा",
  search_rooms: "प्रकल्प शोधा",
  search_articles: "लेख शोधा",
  contacts: "संपर्क",
  suggestions: "सुझाव",
  project_list: "प्रकल्प यादी",
  search_results: "शोध परिणाम",
  add_or_join_project: "प्रकल्प जोडा किंवा सामील व्हा",
  details: "तपशील",
  your_position_within_company: "कृपया कंपनीमध्ये तुमची स्थिती निवडा.",
  close_modal: "बंद करा",
  map: "नकाशा",
  or: "किंवा",
  name: "नाव*",
  street: "रस्ता*",
  house_number: "घर क्रमांक",
  postal_code: "पिन कोड",
  city: "शहर*",
  opened_by: "याद्वारे उघडले:",
  project_No: "प्रकल्प-क्रमांक: ",
  building_type: "इमारत प्रकार*",
  building_types: "इमारत प्रकार",
  add_join: "जोडा/सामील व्हा",
  mandatory_fiels: "*अनिवार्य फील्ड",
  invalid_fiels: "हे फील्ड आवश्यक आहे",
  add_or_join_company: "कंपनी जोडा किंवा सामील व्हा",
  name_of_the_company: "कंपनीचे नाव",
  edit_company_details: "कंपनी तपशील संपादित करा",
  branch_of_the_building_industry: "बांधकाम उद्योगाची शाखा",
  corporate_form: "कॉर्पोरेट फॉर्म",
  position_within_company: "कंपनीमध्ये स्थिती",
  request_confirmation: "प्रलंबित प्रकल्प विनंती",
  company_e_mail: "कंपनी ई-मेल",
  type_of_filter: "फिल्टर करण्यासाठी टाइप करा...",
  setting: "सेटिंग",
  dashboard: "डॅशबोर्ड",
  settings: "सेटिंग्ज",
  views: "दृश्ये",
  times_seen: "वेळा पाहिले",
  see_more: "...अधिक",
  see_less: "...कमी",
  in_search: "शोधात",
  reset_password: "पासवर्ड रीसेट करा",
  submit: "सबमिट करा",
  password: "पासवर्ड",
  email: "ईमेल",
  confirm_password: "पासवर्ड निश्चित करा",
  reset_email: "ई-मेल रीसेट करा",
  update: "अद्यतन करा",
  new_email: "नवीन ई-मेल",
  kjuup_message: "Kjuup संदेश",
  delete_profile: "प्रोफाइल हटवायचे?",
  my_position: "माझी स्थिती:",
  add: "जोडा",
  owner_company_admin: "कंपनी अॅडमिन :",
  owner_company_admin_new: "कंपनी अॅडमिन",
  mutual_contact: "परस्पर संपर्क",
  mutual_contacts: "परस्पर संपर्क",
  co_owner: "सह-मालक",
  managing_director: "व्यवस्थापकीय संचालक",
  associate: "सहयोगी",
  secretary: "सचिव",
  employee: "कर्मचारी",
  project_manage: "प्रकल्प व्यवस्थापक",
  auto_chat_translation: "ऑटो चॅट भाषांतर",
  translate_room_group_names: "चॅट गट नावे भाषांतरित करा",
  translate_room_group_names_info: "सक्षम केल्यावर चॅट गटांची नावे इंटरफेस भाषेत आपोआप भाषांतरित होतात.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "सक्षम केल्यावर, अॅप उघडताना संदेशांऐवजी ई-मेल टॅब डीफॉल्टने उघडेल.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "भाषा",
  english: "इंग्रजी",
  german: "जर्मन",
  french: "फ्रेंच",
  italian: "इटालियन",
  change_language: "भाषा बदला",
  my_companies: "माझ्या कंपन्या",
  employees: "कर्मचारी",
  invite_with_a: "Kjuup मध्ये आमंत्रित करा",
  add_member: "सदस्य जोडा",
  add_user: "वापरकर्ता जोडा",
  send_location: "स्थान पाठवा",
  assign_admin_rights: "अॅडमिन अधिकार समायोजित करा",
  deactivate_company: "कंपनी निष्क्रिय करा",
  remove_employees: "कर्मचारी काढा",
  remove_members: "सदस्य काढा",
  no_user_found: "वापरकर्ता सापडला नाही!",
  approve: "मंजूर करा!",
  deselect_all: "सर्व निवड रद्द करा",
  select_all: "सर्व निवडा",
  translation_on_building_projects: "प्रकल्पांमध्ये भाषांतर",
  reported_capacities: "अहवालित सेवा",
  up_to_50m_exact: "50 मीटर पर्यंत अचूक",
  company_details_service: "कंपनी सेवा",
  company_contact: "कंपनी संपर्क",
  invite_with_link: "Kjuup मध्ये आमंत्रित करा",
  share_link: "लिंक शेअर करा",
  share_company_link: "लिंक शेअर करा",
  qr_code: "QR कोड",
  copy_link: "लिंक कॉपी करा",
  cancel_link: "लिंक रद्द करा",
  who_has_confirmed_services: "तुमच्या सेवा कोणी निश्चित केल्या?",
  projectss: "प्रकल्प",
  add_services: "सेवा जोडा",
  services: "सेवा",
  save_text: "जतन करा",
  share_on: "शेअर करा:",
  articlen: "लेख",
  invite_user_to_confirm_service: "कंपनीला सेवा निश्चित करण्यासाठी वापरकर्त्यांना आमंत्रित करा.",
  link_copied: "लिंक कॉपी केला!",
  email_copied: "ईमेल कॉपी केला!",
  personal_article: "वैयक्तिक लेख",
  company_article: "कंपनी लेख",
  characters_remaining: "उरलेले वर्ण",
  optional_information: "पर्यायी माहिती",
  project: "प्रकल्प",
  projects: "प्रकल्प...",
  abort: "टाकून द्या",
  preview: "पूर्वावलोकन",
  post: "पोस्ट करा",
  of: "चे",
  remove: "काढा",
  free_capacity: "नोकरी पोर्टल",
  current_status_overview: "वर्तमान स्थिती अवलोकन",
  report_capacities: "सेवा अहवाल करा",
  report_text: "अहवाल",
  search_capacities: "ठेकेदार शोधा",
  add_project_user: "प्रकल्प वापरकर्ता जोडा",
  media: "मीडिया",
  links: "लिंक",
  docs: "दस्तऐवज",
  featured_products: "वैशिष्ट्यीकृत उत्पादने...",
  title: "शीर्षक",
  text: "मजकूर",
  feed_details: "फीड तपशील",
  add_employee: "कर्मचारी जोडा",
  latest: "नवीनतम",
  my_projects: "माझे प्रकल्प",
  cancel: "रद्द करा",
  continue: "सुरू ठेवा",
  role_in_the_building_industry: "बांधकाम उद्योगातील भूमिका",
  als: "म्हणून",
  join: "सामील व्हा",
  find: "शोधा",
  request_to_join_a_company: "कंपनीत सामील होण्याची विनंती",
  wants_to_join_the_company: "कंपनीत सामील होऊ इच्छितो",
  filter_by: "द्वारे फिल्टर करा",
  ok: "ठीक आहे",
  close: "बंद करा",
  weekly_statistics: "साप्ताहिक आकडेवारी",
  is_following_you: "तुमचे अनुसरण करत आहे.",
  as: "म्हणून",
  has_joined_the: "कंपनीत सामील झाला आहे",
  has_looked_at_your_profile: "तुमचे प्रोफाइल पाहिले आहे.",
  time: "वेळ",
  in_searches_in_past_week: "गेल्या आठवड्यात शोधांमध्ये.",
  has_liked_your_article: "तुमचा लेख आवडला आहे.",
  has_published_a_new_article: "नवीन लेख प्रकाशित केला आहे.",
  you: "तुम्ही",
  all_views: "सर्व दृश्ये",
  all_profile_views: "सर्व प्रोफाइल दृश्ये",
  mutual_company: "परस्पर कंपनी",
  artical_text: "लेख लिहा...",
  you_have_appeared: "तुम्ही दिसून आला आहात",
  your_request_at_the_company: "कंपनीत तुमची विनंती",
  times_you_have_appeared_in_searches: "वेळा तुम्ही शोधांमध्ये दिसून आला आहात",
  appear_more_often_in_searches: "शोधांमध्ये अधिक वेळा दिसा",
  you_have_been_found: "तुम्हाला सापडले आहे",
  improve_profile: "प्रोफाइल सुधारा",
  choose_existing_contact_for_single_chat: "एकल चॅटसाठी विद्यमान संपर्क निवडा:",
  in_order_to_add_new_contacts: "नवीन संपर्क जोडण्यासाठी कृपया प्रोफाइल पृष्ठावर नवीन संपर्क शोधा.",
  times_in_searches_in_the_last_week: "गेल्या आठवड्यात शोधांमध्ये वेळा. तुमचे प्रोफाइल अद्यतनित करा आणि अधिक सहज सापडण्यासाठी पुढील तपशील जोडा.",
  has_been_confirmed: "निश्चित केले गेले आहे.",
  have_joined_the: "सामील झाले आहेत ",
  building_project: " बांधकाम प्रकल्प.",
  select_with_which_company_you_want_to_connect_to_the_project: "तुम्ही प्रतिनिधित्व करणारी कंपनी निवडा. हे इतर सहभागींना दाखवले जाईल.",
  select_with_which_company_you_want_to_connect_to_the_chat: "तुम्ही प्रतिनिधित्व करणारी कंपनी निवडा. हे इतर सहभागींना दाखवले जाईल.",
  select_internal_section: "कृपया अंतर्गत विभाग निवडा",
  select_profile_image: "प्रोफाइल प्रतिमा निवडा",
  share_user: "वापरकर्ता शेअर करा",
  contact_sender_message:
    "Kjuup चा सदस्य नसलेल्याला Kjuup मध्ये आमंत्रित करण्यासाठी हा लिंक शेअर करा. हा लिंक अनेक लोकांद्वारे नोंदणी करण्यासाठी वापरला जाऊ शकतो.",
  project_sender_message:
    "Kjuup चा सदस्य नसलेल्याला प्रकल्प project name मध्ये आमंत्रित करण्यासाठी हा लिंक शेअर करा. हा लिंक अनेक लोकांद्वारे नोंदणी करण्यासाठी आणि Kjuup मध्ये प्रकल्प project name मध्ये सामील होण्यासाठी वापरला जाऊ शकतो.",
  company_sender_message:
    "Kjuup चा सदस्य नसलेल्याला कंपनी company name मध्ये आमंत्रित करण्यासाठी हा लिंक शेअर करा. हा लिंक अनेक लोकांद्वारे नोंदणी करण्यासाठी आणि Kjuup मध्ये कंपनी company name मध्ये सामील होण्यासाठी वापरला जाऊ शकतो.",
  contact_receivers_message:
    "Kjuup मध्ये सामील होण्यासाठी आमंत्रण लिंक. कृपया kjuup साठी नोंदणी करण्यासाठी लिंकवर क्लिक करा.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "जर तुम्ही Apple App Store द्वारे Kjuup स्थापित करत असाल, तर नोंदणी करण्यास सक्षम होण्यासाठी यशस्वी डाउनलोड नंतर तुम्ही या लिंकवर क्लिक करणे आवश्यक आहे.",
  project_receivers_message:
    "Kjuup मध्ये प्रकल्प project name मध्ये सामील होण्यासाठी आमंत्रण लिंक. कृपया Kjuup साठी नोंदणी करण्यासाठी आणि प्रकल्प project name मध्ये सामील होण्यासाठी लिंकवर क्लिक करा.",
  company_receivers_message:
    "Kjuup मध्ये कंपनी company name मध्ये आमंत्रण लिंक. कृपया Kjuup साठी नोंदणी करण्यासाठी आणि कंपनी company name मध्ये सामील होण्यासाठी लिंकवर क्लिक करा.",
  sign_in: "साइन इन करा",
  enter_your_email_add: "तुमचा ईमेल पत्ता प्रविष्ट करा",
  forgot_password: "पासवर्ड विसरलात",
  dont_have_account: "खाते नाही?",
  register: "नोंदणी करा",
  get_app: "अॅप मिळवा",
  registration: "नोंदणी",
  dep_ing: "Dipl.-Ing.",
  dr: "डॉ.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "प्रोफेसर",
  first_name: "पहिले नाव",
  last_name: "आडनाव",
  have_an_account: "खाते आहे?",
  when_register_you_agree: "नोंदणी करताना तुम्ही आमच्या",
  term_of_use: "वापराच्या अटींशी",
  to: "सहमत आहात.",
  in_our: "आमच्या",
  data_policy: "डेटा धोरणांमध्ये",
  they_find_out: "ते शोधतात,",
  we_provide_store_data: "आम्ही माहिती कशी गोळा करतो, प्रक्रिया करतो आणि संग्रहित करतो.",
  leaving_company_text: "तुम्हाला खरोखर कंपनी सोडायची आहे? कंपनी सोडताना तुम्ही सर्व संबंधित प्रकल्प आणि चॅट ग्रुप देखील सोडता. तुम्ही कोणत्याही वेळी दुसर्या कंपनीसह या प्रकल्पांमध्ये पुन्हा सामील होऊ शकता.",
  delete_profile_text: "तुम्हाला खरोखर तुमचे प्रोफाइल हटवायचे आहे? जेव्हा तुम्ही तुमचे प्रोफाइल हटवता तेव्हा कंपन्या, प्रकल्प आणि चॅटशी सर्व कनेक्शन काढले जातील. तुम्ही कोणत्याही वेळी नवीन प्रोफाइल तयार करू शकता.",
  confirm: "निश्चित करा",
  reject: "नकार द्या",
  requet_to_leave: "सोडण्याची विनंती",
  choose: "निवडा",
  your_add_member: "सदस्य जोडा",
  if_you: "जर तुम्ही",
  can_not_find: "इथे तुमचा संपर्क शोधू शकत नाही.",
  please_wait: "कृपया वाट पहा..",
  imprint_gtc: "इम्प्रिंट/GTC",
  register_confirm_popup: "लॉग इन करण्यापूर्वी तुमचा Kjuup ईमेल सत्यापित करा. आम्ही पुष्टीकरण लिंक पाठवली आहे. दिसत नसल्यास स्पॅम फोल्डरही तपासा.",
  PENDING_GROUP_USER:
    "प्रकल्पात आमंत्रण निश्चित झाल्यानंतरच संदेश प्राप्त करेल. प्रकल्पात आमंत्रण निश्चित झाल्यानंतर एक अतिरिक्त संदेश दिसेल.",
  PENDING: "प्रकल्पात आमंत्रणाची निश्चिती प्रलंबित",
  denied_group_chat: " ने प्रकल्पाचे आमंत्रण नाकारले आहे आणि हा ग्रुप सोडला आहे.",
  joined_group_chat: " या ग्रुपमध्ये सामील झाला आहे",
  you_joined_group_chat: "तुम्ही या ग्रुपमध्ये सामील झाला आहात.",
  Others: "इतर",
  LEFT_GROUP: "ने हा चॅट ग्रुप सोडला आहे.",
  YOU_LEFT_GROUP: "ने हा चॅट ग्रुप सोडला आहे.",
  days: "दिवस",
  day: "दिवस",
  hour: "तास",
  hide_project: "प्रकल्प लपवा",
  hide_project_popup_text: "जर तुम्ही प्रकल्प लपवले तर ते Kjuup मध्ये शोधता येणार नाहीत. फक्त प्रकल्पाचे सदस्य नवीन वापरकर्त्यांना प्रकल्पात आमंत्रित करू शकतात.",
  branch: "शाखा",
  photo_video_media_lib: "फोटो - व्हिडिओ मीडिया लायब्ररी",
  document: "दस्तऐवज",
  location_meeting: "स्थान / बैठक",
  all_member_of_project: "प्रकल्पाचे सर्व सदस्य",
  pending_request: "प्रलंबित प्रकल्प विनंती",
  no_pending_request: "प्रलंबित विनंती सापडली नाही!",
  news_feed: "बातम्या-फीड",
  user_info: "ग्रुप माहिती",
  leave_project: "प्रकल्प सोडा",
  media_link_docs: "फायली",
  search_chat: "चॅट शोधा",
  export_chat_group: "गेल्या महिन्यापासून चॅट ग्रुप डेटा निर्यात करा",
  request_complete_chat_history: "पूर्ण चॅट इतिहास विनंती करा",
  leave_chat_group: "चॅट ग्रुप सोडा",
  add_user_project: "वापरकर्ता जोडा",
  me: "मी",
  max_open_one_to_one: "सध्या कमाल. 2 एक-ते-एक चॅट तळ आणि वरच्या विभागात समांतर उघडले जाऊ शकतात. एकूण कमाल. 4 एक-ते-एक चॅट शक्य आहेत.",
  are_you_sure_you_want_leave_chat: "तुम्हाला खात्री आहे, तुम्ही हा चॅट ग्रुप सोडू इच्छिता?",
  create_group: "ग्रुप तयार करा",
  adding_members: "सदस्य जोडले जात आहेत...",
  creating_the_chat: "चॅट तयार होत आहे...",
  finishing_setup: "सेटअप पूर्ण होत आहे...",
  group_name: "ग्रुप नाव",
  by: "द्वारा:",
  mandetory: "*अनिवार्य",
  delteed: "ने त्याचे/तिचे प्रोफाइल हटवले आहे आणि ग्रुप चॅट सोडला आहे.",
  deleted_direct: "ने त्याचे/तिचे प्रोफाइल हटवले आहे आणि चॅट सोडला आहे.",
  unhidden_message: "जर तुम्ही प्रकल्प दिसवले तर ते Kjuup च्या सर्व सदस्यांद्वारे शोधता येतील.",
  account_deleted: "खाते हटवले गेले आहे.",
  refuse_company: "तुम्हाला खात्री आहे की तुम्ही कंपनीचे आमंत्रण नाकारू इच्छिता?",
  follow_additional: "अतिरिक्त वापरकर्त्यांचे अनुसरण करा",
  f_add: "थेट संदेशांसाठी ते उपलब्ध करण्यासाठी Kjuup च्या अतिरिक्त वापरकर्त्यांचे अनुसरण करा.",
  c_inv: "कंपनी आमंत्रण(े)",
  invited_o_Company: "तुम्हाला कंपनीत सामील होण्यासाठी आमंत्रित केले गेले आहे",
  refuse_companyX: "तुम्हाला खात्री आहे की तुम्ही कंपनी विनंती नाकारू इच्छिता?",
  a_Da: "खाते निष्क्रिय केले गेले आहे.",
  has_deactivated: "ने त्याचे/तिचे प्रोफाइल निष्क्रिय केले आहे.",
  reactive: "ने त्याचे/तिचे प्रोफाइल पुन्हा सक्रिय केले आहे.",
  juup_note: "*वापरकर्तानावासह नोंदणी फक्त Kjuup+ सदस्यांसाठी उपलब्ध आहे",
  username: "वापरकर्तानाव*",
  email_username: "ईमेल/वापरकर्तानाव*",
  sPinText: "कृपया 6-अंकी सुरक्षा PIN प्रदान करा. तुम्ही तुमचा पासवर्ड विसरल्यास हा PIN आवश्यक असेल आणि तुमचे खाते निश्चित करण्यासाठी अनिवार्य आहे.",
  DeleteKjuupPlusText: "तुम्हाला खरोखर तुमचे प्रोफाइल हटवायचे आहे? जेव्हा तुम्ही तुमचे प्रोफाइल हटवता तेव्हा कंपन्या, प्रकल्प आणि चॅटशी सर्व कनेक्शन काढले जातील.\n\nखाते हटवल्यानंतर 48 तासांमध्ये तुम्ही वापरकर्तानाव, पासवर्ड आणि PIN सह साइन इन करून तुमचे खाते पुन्हा सक्रिय करू शकता.",
  reactive_text: "तुमचे खाते हटवले गेले आहे. कृपया तुमचे खाते पुन्हा सक्रिय करण्यासाठी पुन्हा सक्रिय करा वर क्लिक करा.",
  rac: "पुन्हा सक्रिय करा",
  ac_ss: "खाते यशस्वीरित्या पुन्हा सक्रिय केले गेले.",
  not_valid_pin: "PIN अवैध",
  only_for_kjuup: "*वापरकर्तानाव आणि PIN द्वारे पासवर्ड रीसेट फक्त Kjuup+ सदस्यांसाठी उपलब्ध आहे.",
  resetPIN: "PIN रीसेट करा",
  enter_current_pin: "कृपया तुमचा सध्याचा PIN प्रविष्ट करा",
  enter_new: "नवीन PIN प्रविष्ट करा",
  pin_to_confirm: "कृपया निश्चित करण्यासाठी PIN प्रदान करा.",
  change_username: "वापरकर्तानाव रीसेट करा",
  pp_not_match: "पासवर्ड - आणि निश्चित पासवर्ड जुळत नाही",
  reactive_itself: "तुम्ही तुमचे प्रोफाइल पुन्हा सक्रिय केले आहे.",
  has_deactivated_itself: "तुम्ही तुमचे प्रोफाइल निष्क्रिय केले आहे.",
  more_than_two: "सध्या थेट संदेश फक्त 2 वापरकर्त्यांसह समांतर केले जाऊ शकतात.",
  Chats: "थेट संदेश",
  only_in_mobileL: "मूळ व्हिडिओ सध्या फक्त मोबाइल अॅपद्वारे अपलोड आणि पोस्ट केले जाऊ शकतात. कृपया Youtube आणि Vimeo च्या व्हिडिओ लिंक वापरा.",
  register_pin_text: "कृपया तुमचा वैयक्तिक 6-अंकी PIN निवडा. खाते रीसेट कार्यक्षमता सक्षम करण्यासाठी हा PIN आवश्यक असेल.",
  internal_project: "अंतर्गत",
  external_projects: "बाह्य",
  in_deacticted: "अंतर्गत विभाग निष्क्रिय केला गेला आहे.",
  create_article: "लेख तयार करा",
  new_article_selection: "बाह्य बातम्या-फीडसाठी लेख तयार करा",
  new_article_selection_internal: "अंतर्गत लेख तयार करा",
  active_trans_title: "स्वयंचलित भाषांतर चालू करायचे?",
  active_trans: "सक्षम केल्यावर, सर्व आगमन चॅट संदेश तुम्ही निवडलेल्या अॅप भाषेत भाषांतरित केले जातील.",
  disable_trans: "तुम्हाला खरोखर स्वयंचलित भाषांतर निष्क्रिय करायचे आहे?",
  allow_access_chat: "पूर्ण चॅट इतिहास दाखवा",
  toggle_chat_history_on: "तुम्हाला खरोखर वापरकर्त्याला पूर्ण चॅट इतिहास दिसावा असे वाटते?",
  toggle_chat_history_off: "तुम्हाला खरोखर वापरकर्त्याला चॅटमध्ये सामील होण्याच्या बिंदूपासून चॅट इतिहासच दिसावा असे वाटते?",
  check_selected_settings: "कृपया निवडलेल्या सर्व वापरकर्त्यांसाठी चॅट इतिहास सेटिंग्ज तपासा!",
  chat_from_start_have: "तुम्ही या ग्रुपमध्ये सामील झाला आहात. चॅट इतिहास शेअर केला गेला आहे.",
  chat_from_start_has: "या ग्रुपमध्ये सामील झाला आहे. चॅट इतिहास शेअर केला गेला आहे.",
  Address: "पत्ता",
  read_by: "द्वारा वाचले",
  deliver_to: "पाठवले",
  remaining: "उरलेले",
  message_info: "संदेश माहिती",
  request_to_join_only: "सामील होण्याची विनंती",
  unfollow: "अनुसरण करणे थांबवा",
  company_username: "वापरकर्तानाव",
  month: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ],
  remove_my_admin_right: "माझे अॅडमिन अधिकार काढा",
  makeEmp: "तुम्हाला खरोखर वापरकर्त्याकडून कंपनी अॅडमिन अधिकार काढायचे आहेत?",
  remove_my_self: "तुम्हाला खरोखर तुमच्या खात्यातून कंपनी अॅडमिन अधिकार काढायचे आहेत?",
  makeAdmin: "तुम्हाला खरोखर वापरकर्त्याला कंपनी अॅडमिन अधिकार द्यायचे आहेत?",
  remove_member: "सदस्य काढा",
  remove_following_confirm: "तुम्हाला खरोखर {name} ला फॉलो यादीतून काढायचे आहे?",
  remove_follower_confirm: "तुम्हाला खरोखर {name} ला तुमच्या फॉलोअर्स यादीतून काढायचे आहे? काढल्यास त्याला कळणार नाही.",
  do_you_really_want_to_remove: "तुम्हाला खरोखर कंपनीतून वापरकर्तानाव काढायचे आहे?",
  invite_all: "कंपनीच्या सर्व सदस्यांना आमंत्रित करा",
  invite_all_members: "सर्व सदस्यांना आमंत्रित करा",
  mems: "इतर सर्व सदस्य",
  dep_loc: "विभाग/स्थान/टीम",
  depAdmin: "विभाग अॅडमिन",
  add_remove_admin: "कंपनी अॅडमिन पद जोडा/काढा",
  add_remove_dep_admin: "विभाग अॅडमिन पद जोडा/काढा",
  remove_employees_dept: "पासून कर्मचारी काढा",
  want_to_join_dep: "वापरकर्तानाव कंपनी companyname च्या विभाग/स्थान/टीम depname मध्ये सामील होऊ इच्छितो.",
  you_invited: "तुम्हाला कंपनी companyname च्या विभाग/स्थान/टीम depname मध्ये सामील होण्यासाठी आमंत्रित केले गेले आहे.",
  dep_remove: "तुम्हाला खरोखर वापरकर्त्याकडून विभाग किंवा स्थानासाठी अॅडमिन अधिकार काढायचे आहेत?",
  add_dep: "तुम्हाला खरोखर वापरकर्त्याला विभाग किंवा स्थानासाठी अॅडमिन अधिकार द्यायचे आहेत?",
  my_self_dep_remove: "तुम्हाला खरोखर तुमच्या खात्यातून विभाग अॅडमिन अधिकार काढायचे आहेत?",
  member: "सदस्य",
  admin: "अॅडमिन",
  remove_project_admin: "तुम्हाला खरोखर प्रकल्पातून सदस्य काढायचा आहे?",
  remove_my_self_project: "तुम्हाला खरोखर अॅडमिन अधिकार काढायचे आहेत?",
  remove_member_admin_right: "तुम्हाला खरोखर वापरकर्त्याकडून अॅडमिन अधिकार काढायचे आहेत?",
  add_member_admin_right: "तुम्हाला खरोखर वापरकर्त्याला अॅडमिन अधिकार जोडायचे आहेत?",
  add_remove_Poss: "अॅडमिन पद जोडा/काढा",
  forward: "पुढे पाठवा",
  edit: "संपादन करा",
  only_kjuup_plus_can: "फक्त Kjuup+ कंपन्या लेख पोस्ट करू शकतात.",
  add_images: "प्रतिमा(ची) जोडा",
  request_confirmation: 'प्रलंबित प्रकल्प आमंत्रणे',
  Activity: "क्रियाकलाप",
  latest_messages: "नवीनतम संदेश",
  hours: "तास",
  minute: "मिनिटे",
  seconds: "सेकंद",
  days: "दिवस",
  yesterday: "काल",
  last_week: "गेल्या आठवड्यात",
  next_week: "पुढच्या आठवड्यात",
  Last_month: "गेल्या महिन्यात",
  All: "सर्व",
  register_plus: "नोंदणी प्लस",
  select_files: "फाइल निवडा",
  monthsFullName: [
    "जानेवारी",
    "फेब्रुवारी",
    "मार्च",
    "एप्रिल",
    "मे",
    "जून",
    "जुलै",
    "ऑगस्ट",
    "सप्टेंबर",
    "ऑक्टोबर",
    "नोव्हेंबर",
    "डिसेंबर",
  ],
  company_deploc_receivers_message:
    "Kjuup मध्ये कंपनी company name च्या विभागासाठी आमंत्रण लिंक. कृपया Kjuup साठी नोंदणी करण्यासाठी आणि कंपनी company name मध्ये सामील होण्यासाठी लिंकवर क्लिक करा.",
  no_news: "बातम्या उपलब्ध नाहीत",
  reminder: "स्मरणपत्र",
  np_reminder: "ToDo नाहीत",
  move_to_reminder: "ToDo मध्ये हलवा",
  remove_reminder: "तुम्हाला खरोखर तुमच्या ToDo च्या यादीतून हा संदेश काढायचा आहे?",
  remove_all_reminder: "सर्व ToDo काढा",
  remove_all_confirm: "तुम्हाला खरोखर तुमच्या ToDo च्या यादीतून सर्व संदेश काढायचे आहेत?",
  remove_from_reminder: "स्मरणपत्रातून काढा",
  prevent_email: "ई-मेल वापरकर्तानाव म्हणून वापरता येत नाही.",
  allow_noti: "कृपया नोटिफिकेशन परवानगी द्या.",
  join_cap: "सामील व्हा",
  pass_minimum:
    "**पासवर्डला लहान -, मोठे अक्षर, संख्या आणि विशेष वर्णासह 12 वर्ण आवश्यक आहेत.",
  pass_error: "कृपया पासवर्ड आवश्यकता तपासा",
  people_that_like_article: "लेख आवडणारे लोक.",
  people_who_like_article: "तुमचा लेख आवडणारे लोक.",
  message_delete: "हा संदेश हटवला गेला आहे.",
  message_edited: "संपादित",
  edit_message: "संदेश संपादित करा",
  edit_window_expired: "संदेश पाठवल्यानंतर १० मिनिटांतच संपादित करता येतात.",
  message_edit_save: "जतन करा",
  copy: "कॉपी करा",
  bookmark: "बुकमार्क",
  add_reaction: "प्रतिक्रिया जोडा",
  delete_message: "संदेश हटवा",
  more_options: "अधिक पर्याय",
  info: "माहिती",
  link_invite: "लिंकद्वारे आमंत्रित करा",
  ll_nkk: "Kjuup मध्ये आमंत्रित करा",
  selected: "निवडलेले",
  is_active: "सक्रिय",
  inactive: "निष्क्रिय",
  last_online: "शेवटचे ऑनलाइन {{when}}",
  remove_user_l: "काढा",
  link_expire: "प्रत्येक व्युत्पन्न लिंक 72 तासांसाठी वैध असेल.",
  company_language: "कंपनी भाषा",
  company_language_info:
    "भाषा निवड कंपनीशी संबंधित सर्व ईमेल निश्चितीसाठी वापरली जाईल.",
  s_image: "प्रतिमा",
  m_image: "प्रतिमा",
  removeMsg: "काढण्यासाठी टॅप करा",
  block: 'ब्लॉक करा',
  unblock: 'अनब्लॉक करा',
  blocks: 'तुम्हाला खात्री आहे की तुम्ही या वापरकर्त्याला ब्लॉक करू इच्छिता?',
  unblocks: 'तुम्हाला खात्री आहे की तुम्ही या वापरकर्त्याला अनब्लॉक करू इच्छिता?',
  bolcked_click_un_block:
    'तुम्ही हा संपर्क ब्लॉक केला आहे. ब्लॉकिंग काढण्यासाठी येथे क्लिक करा.',
  you_have_unblocked: 'तुम्ही हा संपर्क अनब्लॉक केला आहे.',
  you_have_blocked: 'तुम्ही हा संपर्क ब्लॉक केला आहे.',
  unblock_to_send: 'संदेश पाठवण्यासाठी वापरकर्त्याला अनब्लॉक करा.',
  pilot_text: "बांधकाम विषयांसाठी विशेष AI",
  startup_screen_label: "स्टार्ट स्क्रीन",
  startup_screen_info: "Kjuup सुरू झाल्यावर कोणती स्क्रीन उघडावी ते निवडा.",
  startup_screen_feed: "Home",
  startup_screen_messages: "संदेश",
  startup_screen_saved: "स्टार्ट स्क्रीन अपडेट झाली",
email_on: "ईमेल नोटिफिकेशन चॅट",
  email_on_grp: "ईमेल नोटिफिकेशन",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "या प्रकल्पासाठी ईमेल नोटिफिकेशन सक्रिय किंवा निष्क्रिय करा. हा पर्याय केवळ वैयक्तिक सेटिंग्जद्वारे \"ईमेल नोटिफिकेशन चॅट\" सक्षम केले असतानाच उपलब्ध आहे.",
  todo_notification_info: "जेव्हा जेव्हा तुम्हाला नवीन कार्य नियुक्त केले जाईल तेव्हा तुम्हाला सूचित केले जाईल.",
  info_val: "नवीन चॅट संदेश थोड्या वेळात वाचला न गेल्यास तुम्हाला ईमेल मिळेल. तुम्ही हे विशिष्ट प्रकल्प किंवा चॅटसाठी त्यांच्या सेटिंग्जमध्ये किंवा चॅट ग्रुप माहितीमध्ये बंद करू शकता.",
  email_groups: "या चॅटसाठी ईमेल नोटिफिकेशन सक्रिय किंवा निष्क्रिय करा. हा पर्याय केवळ वैयक्तिक आणि प्रकल्प सेटिंग्जद्वारे \"ईमेल नोटिफिकेशन चॅट\" सक्षम केले असतानाच उपलब्ध आहे.",
  add_update_email: "ईमेल जोडा/अद्यतन करा",
  text_to_verifiy: "\"ईमेल नोटिफिकेशन चॅट\" पर्याय केवळ तुमच्याकडे फाइलवर सत्यापित ईमेल पत्ता असल्यास सक्षम केला जाऊ शकतो.",
  stored_email: "साठवलेला ईमेल: ",
  verify_email: "निश्चिती प्रलंबित!",
  join_call:"सामील व्हा",
  call_is_started:"कॉल सुरू झाला",
  start_chat:"थेट-चॅट सुरू करायचे?",
  project_rooms:"प्रकल्प",
  download_selected:"डाउनलोड करा",
  add_employee_confirm: 'तुम्हाला खात्री आहे की तुम्ही या वापरकर्त्याला कंपनीत जोडू इच्छिता?',
  invalid_deeplink: "अवैध deeplink URL. आवश्यक पॅरामीटर्स गहाळ आहेत.",
  deeplink_error: "deeplink प्रक्रिया करणे शक्य नाही. कृपया नंतर पुन्हा प्रयत्न करा.",
  // Reply functionality translations
  reply: "उत्तर द्या",
  reply_enter: "उत्तर प्रविष्ट करा...",
  reply_sent_successfully: "उत्तर यशस्वीरित्या पाठवले",
  reply_failed: "उत्तर पाठवण्यात अयशस्वी",
  reply_failed_generic: "उत्तर पाठवण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
  replying_to_message: "संदेशाला उत्तर देत आहे",
  cancel_reply: "उत्तर रद्द करा",
  voice_message: "व्हॉईस संदेश",
  send: "पाठवा",
  cancel: "रद्द करा",
  type_your_reply: "तुमचे उत्तर टाइप करा...",
  
  // Auto-suggestion translations
  suggested_replies: "सुझावित उत्तरे",
  suggestions_error: "सुझाव लोड करण्यात अयशस्वी",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "एक क्षण. तुमचा मजकूर तुमच्यासाठी वैयक्तिकरित्या तयार केला जात आहे.",
  loading_chat_message: "चॅट लोड होत आहे...",
  
  // Manual ToDo translations
  extracting_message: "संदेश काढत आहे...",
  create_todo: "ToDo तयार करा",
  create_todo_confirmation: "तुम्ही या संदेशातून ToDo तयार करू इच्छिता?",
  select_project_required: "कृपया प्रकल्प/ग्रुप निवडा",
  only_assigned_can_change_status: "फक्त नियुक्त केलेले वापरकर्ते स्थिती बदलू शकतात",
  todo_summary: "सारांश",
  todo_summary_placeholder: "todo सारांश प्रविष्ट करा...",
  todo_date: "तारीख",
  todo_time: "वेळ",
  todo_date_hint: "मूळ संदेश तारीख/वेळ वापरण्यासाठी रिक्त ठेवा",
  todo_created_success: "ToDo यशस्वीरित्या तयार केले",
  todo_creation_failed: "ToDo तयार करण्यात अयशस्वी",
  create: "तयार करा",
  
  image: "प्रतिमा",
  images: "प्रतिमा",
  remove_all_images: "सर्व प्रतिमा काढा",
  remove_image: "प्रतिमा काढा",
  remove_document: "दस्तऐवज काढा",
  remove_recording: "रेकॉर्डिंग काढा",
  play_recording: "रेकॉर्डिंग प्ले करा",
  upload_image: "प्रतिमा अपलोड करा",
  upload_document: "दस्तऐवज अपलोड करा",
  record_audio: "ऑडिओ रेकॉर्ड करा",
  stop_recording: "रेकॉर्डिंग थांबवा",
  stop_recording_text: "रेकॉर्डिंग थांबवा",
  please_remove_current_attachment: "कृपया सध्याचे अटॅचमेंट काढा",
  please_upload_image_file: "कृपया वैध प्रतिमा फाइल अपलोड करा",
  please_upload_valid_document: "कृपया वैध दस्तऐवज फाइल अपलोड करा",
  searching_messages: "संदेश शोधत आहे...",
  loading_more: "अधिक लोड होत आहे...",
  loading_more_users: "अधिक वापरकर्ते लोड होत आहेत...",
  load_more_users: "अधिक वापरकर्ते लोड करा",
  no_more_users_to_load: "लोड करण्यासाठी अधिक वापरकर्ते नाहीत",
  no_messages_found: "संदेश सापडले नाहीत",
  try_different_keyword: "वेगळी कीवर्ड वापरून पहा किंवा तुमची स्पेलिंग तपासा.",
  search_messages: "संदेश, चॅट गट, प्रकल्प आणि वापरकर्ते शोधा...",
  todo: "ToDo",
  np_todo: "ToDo नाहीत",
  move_to_todo: "ToDo म्हणून सेव्ह करा",
  remove_todo: "तुम्हाला खरोखर ToDo काढायचे आहे?",
  remove_all_todo: "सर्व ToDo काढा",
  remove_all_todo_confirm: "तुम्हाला खरोखर सर्व ToDo काढायचे आहेत?",
  add_to_todo: "ToDo मध्ये जोडा",
  remove_from_todo: "ToDo मधून काढा",
  confirm: "निश्चित करा",
  ok: "ठीक आहे",
  read_more: "अधिक वाचा",
  show_less: "कमी दाखवा",
  show_more: "अधिक दाखवा",
  audio: "ऑडिओ",
  video: "व्हिडिओ",
  // Notification Settings
  notification_schedule: "नोटिफिकेशन वेळापत्रक",
  notification_schedule_desc: "तुम्हाला फक्त निवडलेल्या तासांमध्ये पुश आणि ईमेल नोटिफिकेशन मिळतील. त्या वेळेच्या बाहेर ती पॉज केली जातील.",
  learn_more: "अधिक जाणून घ्या",
  allow_notifications: "नोटिफिकेशन परवानगी द्या:",
  every_day: "प्रत्येक दिवस",
  weekdays: "आठवड्याचे दिवस (सोमवार ते शुक्रवार)",
  custom: "सानुकूल",
  monday: "सोमवार",
  tuesday: "मंगळवार",
  wednesday: "बुधवार",
  thursday: "गुरुवार",
  friday: "शुक्रवार",
  saturday: "शनिवार",
  sunday: "रविवार",
  to: "ते",
  notification_settings: "नोटिफिकेशन",
  notification_settings_saved: "नोटिफिकेशन सेटिंग्ज यशस्वीरित्या सेव्ह केल्या",
  notification_settings_error: "नोटिफिकेशन सेटिंग्ज सेव्ह करण्यात अयशस्वी",
  unavailability_note: "अनुपलब्धता टीप",
  unavailability_description: "ऑफिसबाहेरची टीप सेट करा. सक्रिय असताना, टीप आपल्या सर्व चॅट्समध्ये इतरांना दाखवली जाते आणि सूचना थांबवल्या जातात.",
  unavailability_start_date: "प्रारंभ तारीख",
  unavailability_end_date: "समाप्ती तारीख",
  unavailability_message: "संदेश",
  unavailability_message_hint: "आपल्या परतीच्या तारखेसाठी {endDate} प्लेसहोल्डर म्हणून वापरा.",
  unavailability_replacement: "प्रतिस्थापन संपर्क",
  unavailability_replacement_placeholder: "तातडीच्या विनंत्यांसाठी वापरकर्ता आयडी प्रविष्ट करा",
  unavailability_replacement_current: "सध्याचे प्रतिस्थापन",
  unavailability_replacement_hint: "सेट केल्यास, तातडीच्या बाबींसाठी या व्यक्तीशी संपर्क साधण्याची लिंक आपल्या अनुपलब्धता टीपमध्ये दर्शवली जाईल.",
  unavailability_replacement_none: "प्रतिस्थापन नाही (ऐच्छिक)",
  unavailability_contact_urgent: "तातडीच्या विनंत्यांसाठी संपर्क साधा",
  unavailability_default_message: "मी सध्या कार्यालयात नाही आणि Kjuup वर माझा प्रवेश नाही. मी {endDate} पासून पुन्हा उपलब्ध होईन आणि तेव्हा तुमच्याशी संपर्क साधेन.",
  unavailability_save: "जतन करा",
  unavailability_deactivate: "निष्क्रिय करा",
  unavailability_active_until: "पर्यंत सक्रिय",
  unavailability_saved: "अनुपलब्धता टीप जतन केली",
  unavailability_save_error: "अनुपलब्धता टीप जतन करण्यात अयशस्वी",
  unavailability_deactivated: "अनुपलब्धता टीप निष्क्रिय केली",
  unavailability_end_date_required: "समाप्ती तारीख आवश्यक आहे",
  start_time_before_end_time: "प्रारंभ वेळ समाप्ती वेळेपूर्वी असणे आवश्यक आहे",
  loading: "लोड होत आहे",
  disabled: "अक्षम",
  enable: "सक्षम करा",
  disable: "अक्षम करा",
  forwarded: "फॉरवर्ड केले",
  message_forwarded: "संदेश फॉरवर्ड केला!",
  // Schedule Article
  schedule_article_post: "लेख पोस्ट वेळापत्रक",
  date: "तारीख",
  time: "वेळ",
  scheduled_for_publication: "प्रकाशनासाठी वेळापत्रक",
  article_will_be_published_on: "लेख प्रकाशित होईल:",
  reset_selection: "निवड रीसेट करा",
  continue: "सुरू ठेवा",
  cancel: "रद्द करा",
  // Member Selection
  error_loading_members: "सदस्य लोड करण्यात त्रुटी",
  please_fill_all_fields: "कृपया सर्व फील्ड भरा",
  invalid_email: "अवैध ईमेल पत्ता",
  member_added_successfully: "सदस्य यशस्वीरित्या जोडला",
  error_onboarding_user: "वापरकर्ता जोडण्यात त्रुटी",
  error_creating_chat: "चॅट तयार करण्यात त्रुटी",
  error_creating_group: "ग्रुप तयार करण्यात त्रुटी",
  new_group: "नवीन ग्रुप",
  please_select_or_enter_group_name: "कृपया ग्रुप निवडा किंवा ग्रुप नाव प्रविष्ट करा",
  please_select_or_enter_room_name: "कृपया प्रकल्प निवडा किंवा प्रकल्प नाव प्रविष्ट करा",
  error_creating_room: "प्रकल्प तयार करण्यात त्रुटी",
  error_opening_chat: "चॅट उघडण्यात त्रुटी",
  privacy_modal_text: "चॅटमध्ये प्रकल्प व्यवस्थापकासाठी संबंधित व्यावसायिक सामग्री नसल्यासच \"खाजगी\" निवडा.",
  not_private: "खाजगी नाही",
  private: "खाजगी",
  error_loading_groups: "ग्रुप लोड करण्यात त्रुटी",
  automatic_chat_export: "स्वयंचलित चॅट निर्यात",
  automatic_chat_export_info: "सक्रिय केल्यानंतर, चॅट इतिहास दर महिन्याला निर्दिष्ट ईमेल पत्त्यावर स्वयंचलितपणे पाठवला जाईल.",
  automatic_chat_export_no_email: "स्वयंचलित चॅट निर्यात सक्रिय करण्यासाठी, तुम्हाला प्रथम ईमेल पत्ता जोडावा लागेल. तुम्ही तुमचा ईमेल पत्ता वैयक्तिक सेटिंग्जमध्ये जोडू शकता.",
  enter_email: "ई-मेल प्रविष्ट करा",
  update: "अद्यतन करा",
  confirm: "निश्चित करा",
  export_to_email: "निर्यात खालील ई-मेलवर जाईल.",
  start_chat_button:"नवीन संदेश",
  matching_existing_chats: "अस्तित्वात असलेल्या चॅटशी जुळत आहे",
  subject: "विषय",
  add_subject: "विषय जोडा",
  chat_subject: "चॅट विषय:",
  set_project_room: "प्रकल्प सेट करा",
  matching_existing_project_rooms: "अस्तित्वात असलेल्या प्रकल्पांशी जुळत आहे",
  name_project_room: "प्रकल्प नाव द्या",
  professional_or_private: "व्यावसायिक किंवा खाजगी",
  professional: "व्यावसायिक",
  privacy_modal_text_updated: "चॅटमध्ये प्रकल्प व्यवस्थापकांसाठी संबंधित व्यावसायिक सामग्री नसल्यासच \"खाजगी\" निवडा. खाजगी चॅट प्रकल्प व्यवस्थापकांना दिसत नाहीत.",
  create_internal_chat: "बाह्य - किंवा अंतर्गत चॅट?",
  internal_chat_description: "फक्त तुमच्या कंपनीचे कर्मचारी अंतर्गत चॅटमध्ये जोडले जाऊ शकतात.",
  yes: "होय",
  no: "नाही",
  chat_is_being_created: "चॅट तयार होत आहे...",
  // Additional translations for hardcoded text
  discard_article_confirm: "तुम्हाला या लेखातील बदल खरोखर टाकून द्यायचे आहेत?",
  please_enter_article_title: "कृपया प्रथम लेख शीर्षक प्रविष्ट करा.",
  please_add_mandatory_fields: "कृपया सर्व अनिवार्य फील्ड जोडा",
  product_label: "उत्पादन:",
  no_companies_found: "कंपन्या सापडल्या नाहीत",
  visible_to_all_followers: "सर्व Kjuup सदस्यांना दृश्यमान",
  only_visible_to_employees: "फक्त कर्मचाऱ्यांना दृश्यमान",
  something_went_wrong: "काहीतरी चुकीचे झाले, कृपया पुन्हा प्रयत्न करा",
  please_select_department: "कृपया विभाग/स्थान निवडा",
  schedule: "वेळापत्रक",
  please_select_future_date_time: "कृपया लेख वेळापत्रकासाठी भविष्यातील तारीख आणि वेळ निवडा.",
  please_select_different_date_time: "कृपया लेख वेळापत्रकासाठी वेगळी तारीख किंवा वेळ निवडा.",
  please_select_later_time: "कृपया आजसाठी सध्याच्या वेळेपेक्षा नंतरची वेळ निवडा.",
  unpin_article: "लेख अनपिन करा",
  pin_article: "लेख पिन करा",
  and: "आणि",
  others: "इतर",
  at: "येथे",
  // Chat mute/unmute translations
  mute: "म्यूट",
  unmute: "अनम्यूट",
  chat_muted_successfully: "चॅट यशस्वीरित्या म्यूट केले",
  chat_unmuted_successfully: "चॅट यशस्वीरित्या अनम्यूट केले",
  mute_chat_confirm: "तुम्हाला खरोखर हा चॅट म्यूट करायचा आहे? तुम्हाला नवीन संदेशांसाठी यापुढे नोटिफिकेशन मिळणार नाहीत.",
  unmute_chat_confirm: "तुम्हाला खरोखर हा चॅट अनम्यूट करायचा आहे? तुम्हाला पुन्हा नवीन संदेशांसाठी नोटिफिकेशन मिळतील.",
  please_select_group_to_forward: "कृपया संदेश फॉरवर्ड करण्यासाठी ग्रुप निवडा",
  // Company translations
  record_not_found: "रेकॉर्ड सापडला नाही!",
  please_select_position: "कृपया स्थान निवडा",
  delete_article_confirm: "तुम्हाला खात्री आहे की तुम्ही हा लेख हटवू इच्छिता?",
  delete_company_service_confirm: "तुम्हाला खात्री आहे की तुम्ही कंपनी सेवा हटवू इच्छिता?",
  block_translation_confirm: "तुम्हाला खरोखर कंपनीच्या सर्व सदस्यांसाठी प्रकल्पांमध्ये स्वयंचलित भाषांतर ब्लॉक करायचे आहे",
  unblock_translation_confirm: "तुम्हाला खरोखर कंपनीच्या सर्व सदस्यांसाठी प्रकल्पांमध्ये स्वयंचलित भाषांतर अनब्लॉक करायचे आहे",
  please_select_file: "कृपया अपलोड करण्यासाठी फाइल निवडा",
  role_in_building_industry: "बांधकाम उद्योगातील भूमिका*",
  invalid_email_address: "अवैध ईमेल पत्ता",
  please_enter_password: "कृपया पासवर्ड प्रविष्ट करा",
  password_change_email_sent: "तुमच्या Kjuup ईमेलवर एक ईमेल पाठवण्यात आला आहे. ईमेलमधील पुष्टीकरण लिंकवर क्लिक करून तुमचा नवीन पासवर्ड पुष्टी करा.",
  please_enter_username: "कृपया वापरकर्तानाव प्रविष्ट करा",
  username_same_as_before: "वापरकर्तानाव पूर्वीप्रमाणेच असू शकत नाही",
  profile_deleted_successfully: "प्रोफाइल यशस्वीरित्या हटवले",
  hardware_requirements: "हार्डवेअर आवश्यकता",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU वेग किमान 2GHz<br/>• Windows 7 किंवा अधिक / सर्व macOS आवृत्त्या",
  submitting: "सबमिट करत आहे...",
  signing_in: "साइन इन करत आहे...",
  please_enter_service_name: "कृपया सेवा नाव प्रविष्ट करा",
  something_went_wrong_error: "आहा! काहीतरी चुकीचे झाले...",
  something_went_wrong_try_again: "माफ करा, तेथे काहीतरी चुकीचे झाले. पुन्हा प्रयत्न करा",
  position_label: "स्थान:",
  loading_room: "प्रकल्प लोड होत आहे...",
  navigating_to_room: "प्रकल्पाकडे नेव्हिगेट करत आहे",
  loading_chat: "चॅट लोड होत आहे...",
  translate: "भाषांतर करा",
  show_original: "मूळ दाखवा",
  saving: "सेव्ह होत आहे...",
  language_selection_info: "भाषा निवड कंपनीशी संबंधित सर्व ईमेल निश्चितीसाठी वापरली जाते.",
  // Navigation bar labels
  nav_call: "कॉल",
  nav_home: "मुख्यपृष्ठ",
  nav_messages: "संदेश",
  nav_todo: "कामे",
  nav_rooms: "प्रकल्प",
  nav_all_rooms: "सर्व प्रकल्प",
  pinned_rooms_max: "तुम्ही जास्तीत जास्त 10 प्रकल्प पिन करू शकता.",
  pinned_room_unpin: "अनपिन",
  pinned_rooms_drop: "द्रुत निवडीसाठी तुमचा प्रकल्प येथे ओढा",
  nav_profile: "प्रोफाइल",
  nav_company: "कंपनी",
  nav_company_documents: "कागदपत्रे",
  nav_logout: "लॉगआउट",
  // Create message dialog
  add_member_title: "सदस्य जोडा",
  continue_btn: "सुरू ठेवा",
  search_placeholder: "शोधा",
  no_members_found: "सदस्य सापडले नाहीत",
  no_groups_found: "ग्रुप सापडले नाहीत",
  no_rooms_found: "प्रकल्प सापडले नाहीत",
  search_users_tab: "वापरकर्ते",
  search_documents_tab: "कागदपत्रे",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "फायली नाहीत",
  no_documents_available: "No documents",
  searching_users: "वापरकर्ते शोधत आहे...",
  no_users_found: "कोणतेही वापरकर्ते सापडले नाहीत",
  search_emails_tab: "ईमेल",
  searching_emails: "ईमेल शोधत आहे...",
  no_emails_found: "कोणताही ईमेल सापडला नाही",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "नामहीन ग्रुप",
  unnamed_room: "नामहीन प्रकल्प",
  all_members: "सर्व",
  room_label: "प्रकल्प:",
  subject_label: "विषय:",
  no_members: "सदस्य नाहीत",
  // Loading states for room creation
  creating_structure: "तुमची रचना तयार करत आहे",
  opening_chat: "चॅट उघडत आहे",
  please_wait: "कृपया प्रतीक्षा करा...",
  // ToDo page translations
  loading_todo: "ToDo लोड होत आहे...",
  task_updated: "कार्य अद्यतनित केले",
  error_updating_task: "कार्य अद्यतन करण्यात त्रुटी",
  task_deleted: "कार्य हटवले",
  error_deleting_task: "कार्य हटवण्यात त्रुटी",
  delete_task_confirm: "तुम्हाला खात्री आहे की तुम्ही हे कार्य हटवू इच्छिता?",
  description_label: "वर्णन",
  description_placeholder: "वर्णन प्रविष्ट करा...",
  date_time_label: "तारीख आणि वेळ",
  save_hint: "सेव्ह करण्यासाठी Ctrl+Enter, रद्द करण्यासाठी Esc",
  edit_label: "संपादन करा",
  delete_label: "हटवा",
  todo_list_title: "कामे",
  tasks_count: "कार्ये",
  search_placeholder_todo: "शोधा...",
  select_task_to_open_chat: "चॅट उघडण्यासाठी कार्य निवडा",
  today: "आज",
  yesterday: "काल",
  time_suffix: "", // Empty for Marathi (24h format doesn't need suffix)
  from_chat: "स्रोत ToDo",
  assigned_to: "नियुक्त केले",
  assign_users: "वापरकर्ते नियुक्त करा",
  no_users_assigned: "वापरकर्ते नियुक्त केलेले नाहीत",
  assign: "नियुक्त करा",
  assign_to: "नियुक्त करा...",
  navigate_to_chat: "चॅटवर नेव्हिगेट करा",
  navigate_to_email: "ईमेलकडे नेव्हिगेट करा",
  show_original_message: "स्रोत दाखवा",
  hide_original_message: "स्रोत लपवा",
  status_pending: "प्रलंबित",
  status_in_progress: "प्रगतीत",
  status_completed: "पूर्ण झाले",
  show: "दाखवा",
  close: "बंद करा",
  status_confirmed: "[निश्चित]",
  log_todo_created: "ToDo [तयार केले]",
  log_todo_confirmed: "ToDo [निश्चित केले]",
  log_todo_deleted: "ToDo [हटवले]",
  log_todo_updated: "ToDo [अद्यतनित केले]",
  log_description_updated: "[वर्णन अद्यतनित केले]",
  log_deadline_updated: "[मुदत अद्यतनित केली]",
  log_assigned_to: "[नियुक्त केले] {name}",
  log_unassigned_from: "[नियुक्ती काढली] {name}",
  log_assignment_added: "[नियुक्ती जोडली]: {name}",
  log_assignment_removed: "[नियुक्ती काढली]: {name}",
  log_status_updated: "[स्थिती बदलली] {from} [पासून] {to}",
  log_status_changed: "[स्थिती बदलली]",
  log_status_changed_to: "[स्थिती बदलली] {status}",
  log_changed_status_to: "[स्थिती बदलली]:",
  log_for_user: "[वापरकर्त्यासाठी]:",
  log_user_updated_status: "[वापरकर्त्याने त्यांची todo स्थिती अद्यतनित केली]",
  log_changed_date_to: "[तारीख बदलली]:",
  log_changed_description_to: "[वर्णन बदलले]:",
  log_moved_to: "[हलवले] {status}",
  todo_status_updated_from: "[पासून]",
  todo_status_updated_to: "[ला]",
  filter_pending: "प्रलंबित",
  filter_confirmed: "पुष्टी झाली",
  filter_assigned_to_me: "माझी कार्ये",
  filter_assigned_by_me: "सोपवलेले",
  todo_project_label: "प्रकल्प:",
  assigned_users: "नियुक्त वापरकर्ते:",
  todo_chat_label: "चॅट:",
  history: "इतिहास",
  todo_assigned_by: "यांनी नियुक्त केले:",
  todo_assigned_push: "नियुक्त ToDo:",
  todo_assigned_push_empty: "तुम्हाला नवीन ToDo नियुक्त केले आहे.",
  search_groups: "गट",
  search_chat_groups: "चॅट गट",
  search_project_room: "प्रकल्प",
  search_messages_tab: "संदेश",
  searching_groups: "गट शोधत आहे...",
  searching_rooms: "प्रकल्प शोधत आहे...",
  no_groups_found: "कोणताही गट आढळला नाही",
  no_rooms_found: "कोणताही प्रकल्प आढळला नाही",
  create_poll: "Poll",
  poll_question_label: "QUESTION",
  poll_question_placeholder: "Ask a question",
  poll_options_label: "OPTIONS",
  poll_option: "Option",
  poll_add_option: "Add option",
  poll_allow_multiple: "Allow multiple answers",
  poll_multiple_allowed: "Select one or more options",
  poll_select_option: "Select one option",
  poll_view_votes: "View votes",
  poll_vote_singular: "vote",
  poll_vote_plural: "votes",
  poll_votes: "Poll votes",
  poll_no_votes_yet: "No votes yet",
  transcript_step_processing: "ट्रान्सक्रिप्शन सुरू आहे...",
  ai_transcript_tab: "AI-ट्रान्सक्रिप्ट",
  ai_transcript_info: "केवळ 09.03.2026 नंतर तयार केलेल्या व्हॉइस संदेशांसाठी उपलब्ध.",
  transcript_more: "...अधिक",
  transcript_less: "...कमी",
  ki_transcript_voice_message: "KI-व्हॉइस मेसेज ट्रान्सक्रिप्ट",
  ki_image_analysis: "AI-आधारित प्रतिमा विश्लेषण",
  type_message: "संदेश टाइप करा",
  email_tab_messages: "संदेश",
  email_tab_email: "ई-मेल",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "ई-मेल खाती",
  email_connect_gmail: "Gmail कनेक्ट करा",
  email_connect_outlook: "Outlook कनेक्ट करा",
  email_no_accounts: "कनेक्ट केलेली ई-मेल खाती नाहीत",
  email_no_accounts_hint: "तुमच्या प्रोफाइल सेटिंग्जमध्ये ई-मेल खाते कनेक्ट करा",
  email_no_messages: "ई-मेल नाहीत",
  email_from: "कडून",
  email_to: "ला",
  email_subject: "विषय",
  email_disconnect: "डिस्कनेक्ट करा",
  email_disconnect_confirm: "तुम्हाला खात्री आहे का की तुम्ही हे ईमेल खाते डिस्कनेक्ट करू इच्छिता? सर्व सिंक केलेले ईमेल काढून टाकले जातील.",
  email_account_disconnected: "ईमेल खाते यशस्वीरित्या डिस्कनेक्ट केले",
  email_account_disconnect_failed: "खाते डिस्कनेक्ट करण्यात अयशस्वी",
  email_connecting: "कनेक्ट होत आहे...",
  email_account_connected: "खाते यशस्वीरित्या कनेक्ट झाले",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "सेटिंग्जवर जा",
  email_date: "तारीख",
  email_reply: "उत्तर द्या",
  email_forward: "फॉरवर्ड करा",
  email_copy_text: "मजकूर कॉपी करा",
  email_text_copied: "कॉपी केले!",
  email_text_copy_failed: "मजकूर कॉपी करता आला नाही.",
  email_delete: "हटवा",
  email_not_spam: "स्पॅम नाही",
  email_not_spam_success: "ईमेल इनबॉक्समध्ये हलवला.",
  email_not_spam_failed: "इनबॉक्समध्ये हलवणे अयशस्वी.",
  email_delete_confirm: "तुम्हाला खरोखरच हा ईमेल हटवायचा आहे का?",
  email_delete_from_folder: "तुम्हाला {folder} मधून हटवायचे आहे का?",
  email_delete_permanent_from_folder:
    "तुम्हाला {folder} मधून कायमस्वरूपी हटवायचे आहे का? ही क्रिया पूर्ववत केली जाऊ शकत नाही.",
  email_save_draft_confirm: "हा ईमेल मसुदा म्हणून जतन करायचा का?",
  email_save_draft: "मसुदा जतन करा",
  email_discard: "टाकून द्या",
  email_back_to_compose: "लिहिण्याकडे परत जा",
  email_draft_saved: "मसुदा जतन केला.",
  email_draft_save_failed: "मसुदा जतन करणे अयशस्वी.",
  email_loading: "ई-मेल लोड होत आहेत...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Select",
  email_attachment_singular: "Attachment",
  email_attachment_plural: "Attachments",
  email_back: "Back",
  email_download: "Download",
  email_close: "Close",
  email_preview: "Preview",
  email_preview_not_available: "पूर्वावलोकन उपलब्ध नाही",
  email_preview_failed: "पूर्वावलोकन उपलब्ध नाही",
  select_attachments: "अटॅचमेंट निवडा",
  email_loading_preview: "Loading preview...",
  email_mark_unread_failed: "email(s) could not be marked as unread.",
  email_delete_failed: "email(s) could not be deleted.",
  filter_all: "सर्व",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "थेट संदेश",
  my_notes: "My Space",
  filter_internal_groups: "अंतर्गत गट चॅट",
  filter_external_groups: "बाह्य गट चॅट",
  filter_group_chats: "गट चॅट",
  filter_groups_internal: "अंतर्गत",
  filter_groups_external: "बाह्य",
  filter_unread_only: "फक्त न वाचलेले",
  room_daily_briefing_info: "सक्षम केल्यावर, वैयक्तिक सेटिंग्जमध्ये नमूद केलेल्या वेळी दर २४ तासांनी या प्रकल्पाचा अहवाल तयार होतो — पण फक्त त्या कालावधीत हालचाल झाली असेल तर.",
  email_select_all: "सर्व निवडा",
  email_deselect_all: "सर्व निवड रद्द करा",
  email_reply_all: "सर्वांना उत्तर द्या",
  email_reply_placeholder: "तुमचे उत्तर टाइप करा...",
  email_forward_placeholder: "संदेश जोडा...",
  email_edit_draft: "मसुदा संपादित करा",
  email_attach: "जोडा",
  email_attachment_from_original: "मूळ संदेशातून",
  email_remove: "काढा",
  email_drop_files: "जोडण्यासाठी फाइल्स ड्रॉप करा",
  email_loading_attachments: "संलग्नक लोड होत आहेत...",
  email_archive: "संग्रहित करा",
  mark_unread: "न वाचलेले म्हणून चिन्हांकित करा",
  mark_read: "वाचलेले म्हणून चिन्हांकित करा",
  email_all_accounts: "सर्व खाती",
  email_error: "त्रुटी",
  email_delete_email_failed: "ईमेल हटवता आले नाही.",
  enter_url: "URL प्रविष्ट करा",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'आत्ता सबस्क्राइब करा',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '१ महिना मोफत ट्रायल',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'आज पेमेंट नाही. सशुल्क सदस्यता सुरू होण्यापूर्वी क्रेडिट कार्ड तपशील मागितले जात नाहीत.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'सर्व ईमेल खाती थेट Kjuup मध्ये व्यवस्थापित करा',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI उत्तरे लिहितो – तुम्ही फक्त पुष्टी करा',
  kjuup_io_feature_tasks: 'कार्ये आणि कॅलेंडर नेहमी आपोआप अद्ययावत',
  kjuup_io_choose_plan: 'प्लॅन निवडा',
  kjuup_io_plan_monthly: 'मासिक',
  kjuup_io_plan_yearly: 'वार्षिक',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Stripe द्वारे सुरक्षित · कधीही रद्द करा',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'पेमेंट मिळाले. तुमचे सबस्क्रिप्शन सक्रिय करत आहे…',
  kjuup_io_toast_activating_soon: 'पेमेंट मिळाले. तुमचे सबस्क्रिप्शन लवकरच सक्रिय होईल.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} तास बाकी',
  kjuup_io_trial_left_hour: '1 तास बाकी',
  kjuup_io_trial_left_minutes: '{count} मिनिटे बाकी',
  kjuup_io_trial_left_minute: '1 मिनिट बाकी',
  kjuup_io_trial_left_seconds: '{count} सेकंद बाकी',
  kjuup_io_trial_left_second: '1 सेकंद बाकी',
  kjuup_io_trial_ending_now: 'तुमचा ट्रायल संपत आहे…',
  kjuup_io_request_timeout: 'कनेक्शनची वेळ संपली. कृपया पुन्हा प्रयत्न करा.',
  kjuup_io_info_days_free: '{days} दिवस पूर्णपणे मोफत – सदस्यता ट्रायलनंतरच सुरू होते.',
  kjuup_io_discount_total: 'तुमची सूट: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'वैयक्तिक: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'बंद करा',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'तुमचा मोफत ट्रायल संपला आहे',
  kjuup_io_trial_ended_body: 'ईमेल आणि इतर प्रीमियम वैशिष्ट्ये वापरत राहण्यासाठी Kjuup.io चे सबस्क्रिप्शन घ्या.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'तुमचा मोफत ट्रायल सुरू झाला आहे',
  kjuup_io_toast_trial_fail: 'मोफत ट्रायल सुरू करता आला नाही',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / महिना',
  kjuup_io_save_amount_year: 'दरवर्षी {price} वाचवा',
  kjuup_io_billed_annually_amount: '{price} वार्षिक बिल',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'तुम्हाला काय मिळते:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'क्रेडिट कार्ड आवश्यक नाही – पेमेंट तपशीलांशिवाय लगेच सुरू करा.',
  kjuup_io_info_cancel_anytime: 'कधीही रद्द करा – कोणतेही बंधन नाही, धोका नाही.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'बिलिंग कालावधी',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'पेमेंट पद्धत जतन केली. ट्रायल संपल्यावर शुल्क आकारले जाईल.',
  calendar_sync_info: 'सर्व Kjuup ToDo आपल्या कॅलेंडरशी आपोआप सिंक करा.',
  calendar_no_accounts: 'अद्याप कोणतेही कॅलेंडर जोडलेले नाही.',
  article_new_badge: 'नवीन',
  article_new_posts: '{0} नवीन पोस्ट',
  documents: 'दस्तऐवज',
  add_documents: 'दस्तऐवज जोडा',
  no_preview_available: 'पूर्वावलोकन उपलब्ध नाही',
  no_preview_hint: 'या प्रकारच्या फाइलचे पूर्वावलोकन करता येत नाही, परंतु ती तरीही पाठवली जाईल.',
  max_documents_reached: 'तुम्ही एका वेळी जास्तीत जास्त 10 दस्तऐवज जोडू शकता.',
  open_file: 'फाइल उघडा',
  twofa_title: 'दोन-घटक प्रमाणीकरण',
  twofa_method_totp: 'ऑथेंटिकेटर अॅप',
  twofa_method_sms: 'मजकूर संदेश',
  twofa_method_email: 'ईमेल',
  twofa_enter_app: 'ऑथेंटिकेटर अॅपमधील ६ अंकी कोड टाका.',
  twofa_enter_sms: 'एसएमएसने पाठवलेला ६ अंकी कोड टाका.',
  twofa_enter_email: 'ईमेलवर पाठवलेला ६ अंकी कोड टाका.',
  twofa_resend: 'कोड पुन्हा पाठवा',
  twofa_try_another: 'दुसरी पद्धत वापरा',
  twofa_remember_device: 'या डिव्हाइसवर ३० दिवस विचारू नका',
  twofa_sent: 'आम्ही एक कोड पाठवला आहे.',
  twofa_invalid_code: 'हा कोड चुकीचा आहे. पुन्हा प्रयत्न करा.',
  twofa_something_wrong: 'काहीतरी चुकले. पुन्हा प्रयत्न करा.',
  twofa_method_unavailable: 'ही पडताळणी पद्धत उपलब्ध नाही.',
  twofa_on_desc: 'दोन-घटक प्रमाणीकरण चालू आहे. प्रत्येक साइन इनला कोड लागेल.',
  twofa_off_desc: 'पासवर्डनंतर दुसरे पाऊल जोडा. ऑथेंटिकेटर अॅप सर्वात सुरक्षित आहेत.',
  twofa_methods: 'पद्धती',
  twofa_on: 'चालू',
  twofa_add: 'जोडा',
  twofa_default_method: 'डीफॉल्ट पद्धत',
  twofa_default: 'डीफॉल्ट',
  twofa_turn_off: 'बंद करा',
  twofa_disable_hint: 'दोन-घटक प्रमाणीकरण बंद करण्यासाठी पासवर्ड आणि सध्याचा कोड टाका.',
  twofa_disable_need: 'पासवर्ड आणि पडताळणी कोड टाका.',
  twofa_code_placeholder: '६ अंकी कोड किंवा बॅकअप कोड',
  twofa_send_code: 'कोड पाठवा',
  twofa_primary_updated: 'डीफॉल्ट पद्धत अद्ययावत झाली.',
  twofa_disabled: 'दोन-घटक प्रमाणीकरण आता बंद आहे.',
  twofa_enabled: 'दोन-घटक प्रमाणीकरण आता चालू आहे.',
  twofa_totp_help: 'हा QR कोड Google Authenticator, Authy किंवा 1Password ने स्कॅन करा. की हातानेही टाकता येते.',
  twofa_secret_copied: 'की कॉपी झाली',
  twofa_sms_help: 'आंतरराष्ट्रीय स्वरूपात मोबाइल नंबर टाका. आम्ही ६ अंकी कोड एसएमएसने पाठवू.',
  twofa_email_help: 'आम्ही तुमच्या खात्याच्या ईमेलवर ६ अंकी कोड पाठवू.',
  twofa_backup_title: 'बॅकअप कोड',
  twofa_backup_help: 'हे एकदा वापरायचे कोड सुरक्षित ठिकाणी ठेवा. फोन हरवल्यास प्रत्येक कोड एकदा चालतो.',
  twofa_copy_codes: 'कोड कॉपी करा',
  twofa_codes_copied: 'बॅकअप कोड कॉपी झाले',
  twofa_regenerate: 'नवीन बॅकअप कोड मिळवा',
  twofa_regenerate_hint: 'यामुळे न वापरलेले बॅकअप कोड बदलले जातात. पासवर्ड आणि सध्याचा कोड टाका.',
  twofa_backup_remaining: '{n} न वापरलेले बॅकअप कोड शिल्लक',
  twofa_new_codes: 'नवीन बॅकअप कोड',
  twofa_sms_unavailable: 'एसएमएस कोड अद्याप उपलब्ध नाहीत.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "तुम्हाला नेमलेली Kjuup कामे तुमच्या Todoist मधील Kjuup प्रकल्पात कॉपी होतात. Todoist मधील बदल परत कॉपी होत नाहीत.",
  todoist_connect: "Todoist जोडा",
  todoist_connected: "Todoist जोडले",
  todoist_connect_failed: "Todoist कनेक्शन अयशस्वी",
  todoist_disconnect: "डिस्कनेक्ट",
  todoist_disconnected: "Todoist डिस्कनेक्ट झाले",
  todoist_disconnect_confirm: "Todoist डिस्कनेक्ट करायचे? Todoist मधील कामे तशीच राहतात. सिंक थांबते.",
  todoist_sync_now: "आता सिंक करा",
  todoist_syncing: "सिंक होत आहे…",
  todoist_sync_done: "सिंक पूर्ण",
  todoist_sync_failed: "सिंक अयशस्वी",
  todoist_auth_error: "सिंक सुरू ठेवण्यासाठी Todoist पुन्हा जोडा.",
  todoist_last_sync: "शेवटचे सिंक",
  todoist_not_connected: "Todoist जोडलेले नाही",
  todoist_auth_url_failed: "Todoist अधिकृतता पृष्ठ उघडता आले नाही.",
  recommend_text: "Kjuup मध्ये सामील हो, जोडलेला राहा आणि तुझा संवाद व्यवस्थित ठेव. तुझे सर्व चॅनेल एकत्र आण, संदेश योग्य प्रकल्पांमध्ये ठेव आणि प्रत्येक सकाळची सुरुवात सारांश आणि तुझ्या कामांनी कर – सर्व काही तू आधीच वापरत असलेल्या ॲप्ससोबत सिंक. मोफत सुरुवात कर:",
  pro_auth_signin_title: 'पुन्हा स्वागत आहे',
  pro_auth_signin_sub: 'तुमच्या कामाच्या ईमेलने साइन इन करा.',
  pro_auth_email_or_username: 'ईमेल किंवा वापरकर्तानाव',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'पासवर्ड विसरलात?',
  pro_auth_create_account: 'खाते तयार करा',
  pro_auth_show_password: 'पासवर्ड दाखवा',
  pro_auth_hide_password: 'पासवर्ड लपवा',
  pro_auth_register_sub: 'तुमच्या ईमेलची पुष्टी करण्यासाठी आम्ही तुम्हाला लिंक पाठवू.',
  pro_auth_register_plus_sub: 'वापरकर्तानाव आणि पासवर्ड निवडा. पुढे तुम्ही तुमचा सुरक्षा PIN सेट कराल.',
  pro_auth_check_credentials: 'तुमचा ईमेल आणि पासवर्ड तपासा',
  pro_news_export_pdf: 'PDF म्हणून एक्सपोर्ट करा',
  pro_news_pdf_failed: 'PDF तयार करता आली नाही.',
  pro_news_pdf_attachments: 'संलग्नके',
  pro_news_pdf_video: 'व्हिडिओ',
  pro_auth_forgot_sub: 'तुमचा ईमेल प्रविष्ट करा आणि आम्ही तुम्हाला पासवर्ड रीसेट करण्यासाठी लिंक पाठवू.',
  pro_auth_send_link: 'रीसेट लिंक पाठवा',
  pro_auth_plus_reset: 'PIN ने रीसेट करा',
  pro_auth_show_pin: 'PIN दाखवा',
  pro_auth_hide_pin: 'PIN लपवा',
  v2_auth_plus_only: 'फक्त Kjuup+',
  room_action_media: "फायली",
  room_tab_overview: "आढावा",
  room_tab_history: "इतिहास",
  chat_info_media: "फायली",
  messages: "संदेश",
  pro_todo_project_required: "कृपया एक प्रकल्प निवडा",
  pro_todo_choose_project: "हे काम कोणत्या प्रकल्पासाठी आहे?",
  cockpit_report_delete_confirm: "हा दैनिक अहवाल हटवायचा?",
  cockpit_report_deleted: "दैनिक अहवाल हटवला",
  cockpit_tab_company: "कंपनी",
  cockpit_bookmarked_priorities: "बुकमार्क केलेली कार्ये",
  cockpit_load_error: "कॉकपिट लोड करता आले नाही.",
  cockpit_retry: "पुन्हा प्रयत्न करा",
  cockpit_yesterday: "काल",
  cockpit_greeting_morning: "शुभ प्रभात",
  cockpit_greeting_day: "शुभ दुपार",
  cockpit_greeting_evening: "शुभ संध्याकाळ",
  cockpit_assistant_q_open: "आज काय प्रलंबित आहे?",
  cockpit_assistant_q_summarize: "{{room}} चॅटचा सारांश द्या",
  cockpit_assistant_q_overdue: "कोणती कार्ये मुदतीबाहेर आहेत?",
  cockpit_assistant_new: "{{n}} नवीन",
  cockpit_assistant_important: "{{n}} महत्त्वाचे",
  cockpit_assistant_title: "Kjuup सहाय्यक",
  cockpit_assistant_hint: "टॅप करा आणि विचारा",
  room_overview_priority_no_detail: "अहवालात या प्राधान्याबद्दल अधिक तपशील नाहीत.",
  room_overview_priority_from: "स्रोत: {{name}}",
  room_overview_priority_open_task: "कार्य उघडा",
  cockpit_priority_position: "{{total}} पैकी {{index}} प्राधान्य",
  room_overview_today_title: "आज महत्त्वाचे",
  room_overview_all_tasks: "सर्व",
  room_overview_tasks_empty: "कोणत्याही खुल्या मुदती किंवा कार्ये नाहीत",
  room_overview_appointments_empty: "कोणत्याही आगामी भेटी नाहीत",
  room_overview_no_priorities: "ताज्या अहवालात कोणतीही खुली प्राधान्ये नाहीत.",
  cockpit_report_top5: "शीर्ष 5 प्राधान्ये",
  cockpit_report_todo_created: "कार्य तयार केले",
  cockpit_report_source_missing: "स्रोत संदेश सापडला नाही.",
  delete_bookmarked_priority_confirm: "हे बुकमार्क केलेले कार्य हटवायचे आहे का?",
  cockpit_report_create_todo: "कार्य तयार करा",
  cockpit_priorities_deleting: "हटवत आहे …",
  cockpit_priorities_select: "अनेक हटवा",
  cockpit_report_none: "कोणतीही नोंद नाही.",
  cockpit_priorities_delete_confirm: "{count} बुकमार्क केलेली कार्ये हटवायची आहेत का?",
  cockpit_priorities_delete_failed: "{count} कार्ये हटवता आली नाहीत",
  cockpit_priorities_deleted: "{count} कार्ये हटवली",
  cockpit_priorities_selected: "{count} निवडले",
  cockpit_channel_connected: "जोडलेले",
  cockpit_channel_not_connected: "जोडलेले नाही",
  cockpit_channel_connect: "जोडा",
  cockpit_channel_chat: "Kjuup चॅट",
  cockpit_channel_active: "सक्रिय",
  cockpit_channel_hidden: "लपवलेले",
  cockpit_channel_enable: "सक्षम करा",
  cockpit_channel_email: "ईमेल",
  cockpit_channel_check: "कनेक्शन तपासा",
  cockpit_channel_fix: "तपासा",
  cockpit_channel_forward: "फॉरवर्डिंग पत्ता",
  cockpit_channel_not_set_up: "सेट केलेले नाही",
  cockpit_channel_set_up: "सेट करा",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "कनेक्शन तुटले",
  cockpit_channel_importing: "आयात करत आहे",
  cockpit_channel_removing: "डिस्कनेक्ट करत आहे",
  cockpit_channel_reconnect: "पुन्हा जोडा",
  cockpit_channels_title: "चॅनेल",
  cockpit_company_role_super_admin: "कंपनी प्रशासक",
  cockpit_company_role_dept_admin: "विभाग प्रशासक",
  cockpit_company_role_member: "कर्मचारी",
  cockpit_company_none: "Kjuup+ कंपनी सापडली नाही",
  cockpit_company_eyebrow: "कंपनी",
  cockpit_company_inactive: "निष्क्रिय",
  cockpit_company_settings: "कंपनी सेटिंग्ज",
  cockpit_company_employees: "कर्मचारी",
  cockpit_company_internal_rooms: "अंतर्गत प्रकल्प",
  cockpit_report_all_projects: "सर्व प्रकल्प",
  cockpit_report_progress_emails: "ईमेल्सचे विश्लेषण करत आहे",
  cockpit_report_progress_chats: "चॅट संदेशांचे विश्लेषण करत आहे",
  cockpit_report_progress_documents: "संलग्नके आणि दस्तऐवजांचे विश्लेषण करत आहे",
  cockpit_report_progress_tasks: "कार्यांचे विश्लेषण करत आहे",
  cockpit_report_progress_summarizing: "मजकुराचे विश्लेषण करत आहे",
  cockpit_report_progress_reading: "आधी विश्लेषण केलेला मजकूर पुन्हा वापरत आहे",
  cockpit_report_progress_collecting: "तुमच्या प्रकल्पांमधून ईमेल्स, चॅट आणि कार्ये गोळा करत आहे",
  cockpit_report_progress_priorities: "प्राधान्ये, अंतिम मुदती आणि निर्णय एकत्र करत आहे",
  cockpit_report_progress_queued: "अहवाल तयार करत आहे",
  cockpit_report_creating_title: "तुमचा दैनिक अहवाल तयार केला जात आहे",
  cockpit_report_progress_count_one: "1 आयटमचे विश्लेषण केले",
  cockpit_report_progress_count_many: "{{count}} आयटमचे विश्लेषण केले",
  cockpit_report_progress_hint: "यास साधारणपणे एक ते दोन मिनिटे लागतात – तोपर्यंत तुम्ही कॉकपिट वापरत राहू शकता.",
  cockpit_report_time_hint: "सर्वाधिक सक्रिय पाच प्रकल्पांसाठी दैनिक अहवाल दररोज {{hour}}:00 वाजता तयार केला जातो.",
  room_overview_priorities_title: "सद्यस्थिती आणि प्राधान्ये",
  room_overview_as_of: "{{time}} पर्यंत",
  cockpit_report_delete: "दैनिक अहवाल हटवा",
  email_tag_daily_briefing: "दैनिक अहवाल",
  cockpit_report_unread: "नवीन",
  cockpit_report_clear_project: "सर्व प्रकल्प दाखवा",
  cockpit_filter_project: "प्रकल्प",
  cockpit_filter_all_projects: "सर्व प्रकल्प",
  cockpit_report_recreate: "दैनिक अहवाल पुन्हा तयार करा",
  cockpit_report_hide_previous: "मागील दैनिक अहवाल लपवा",
  cockpit_report_show_previous: "मागील दैनिक अहवाल दाखवा",
  cockpit_report_room_empty: "या प्रकल्पासाठी अद्याप दैनिक अहवाल नाही",
  cockpit_report_empty: "अद्याप दैनिक अहवाल नाही",
  cockpit_report_room_empty_hint: "फक्त या प्रकल्पासाठी दैनिक अहवाल तयार करा.",
  cockpit_report_needs_mailbox: "Kjuup ला स्वयंचलित कार्यांसह दैनिक अहवाल तयार करता यावा यासाठी ईमेल खाते जोडा.",
  cockpit_report_create: "दैनिक अहवाल तयार करा",
  cockpit_email_connect: "ईमेल जोडा",
  cockpit_email_none_title: "अद्याप कोणतेही ईमेल खाते जोडलेले नाही",
  cockpit_email_none_reports: "तुमचा मेलबॉक्स जोडा, जेणेकरून Kjuup येणारे ईमेल्स तुमच्या प्रकल्पांना नियुक्त करेल आणि कार्यांसह दैनिक अहवाल तयार करेल.",
  cockpit_email_none_client: "Kjuup.io मध्येच ईमेल वाचण्यासाठी, नियुक्त करण्यासाठी आणि उत्तर देण्यासाठी Gmail, Outlook किंवा IMAP जोडा.",
  cockpit_email_reports_title: "सध्याचा ईमेल क्लायंट",
  cockpit_email_reports_text: "Kjuup.io मध्ये इनबॉक्स नाही · दररोज {{hour}}:00 वाजता दैनिक अहवालासह {{rooms}} प्रकल्प · येणारे ईमेल्स तुमच्या प्रकल्पांना नियुक्त केले जातात.",
  cockpit_email_reports_rooms: "प्रकल्प व्यवस्थापित करा",
  cockpit_email_settings: "ईमेल सेटिंग्ज",
  cockpit_email_error_title: "कनेक्शन तपासा",
  cockpit_email_client_title: "इनबॉक्स जोडलेला आहे",
  cockpit_email_accounts_n: "{{n}} खाते जोडले",
  cockpit_email_last_sync: "शेवटचे सिंक {{when}}",
  cockpit_email_report_at: "{{hour}}:00 वाजता दैनिक अहवाल",
  cockpit_email_open_inbox: "इनबॉक्स उघडा",
  cockpit_email_eyebrow: "Kjuup-ईमेल",
  cockpit_email_accounts_label: "जोडलेले ईमेल पत्ते",
  email_folder_sent: "पाठवलेले आयटम",
  email_no_subject: "(विषय नाही)",
  cockpit_email_detail_loading: "ईमेल लोड होत आहे …",
  cockpit_email_detail_failed: "ईमेल लोड करता आला नाही.",
  cockpit_email_detail_empty: "या ईमेलमध्ये मजकूर नाही.",
  cockpit_personal_settings: "वैयक्तिक सेटिंग्ज",
  cockpit_companies: "कंपन्या",
  cockpit_title: "कॉकपिट",
  cockpit_back: "आढाव्याकडे परत",
  cockpit_day_overview: "तुमचा दिवस एका दृष्टिक्षेपात",
  email_saved_to_project: "ईमेल प्रकल्पात जतन केला",
  email_classify_need_project: "कृपया प्रकल्पाचे नाव प्रविष्ट करा",
  cockpit_email_deleted: "ईमेल हटवला",
  cockpit_email_sent_empty: "अद्याप पाठवलेले ईमेल नाहीत.",
  cockpit_email_incoming_empty: "अद्याप येणारे ईमेल नाहीत.",
  cockpit_email_incoming_title: "ईमेल्स",
  cockpit_email_incoming_sub: "येणारे आणि पाठवलेले ईमेल्स तुमच्या प्रकल्पांना नियुक्त करा. नियुक्ती येथे बदलता येते.",
  cockpit_email_incoming_unassigned_n: "{{n}} नियुक्त नाहीत",
  cockpit_email_folder_inbox: "इनबॉक्स",
  cockpit_email_folder_sent: "पाठवलेले",
  cockpit_email_open: "ईमेल उघडा",
  cockpit_email_incoming_suggested: "सुचवलेले: {{room}}",
  cockpit_email_incoming_apply: "लागू करा",
  cockpit_email_incoming_adjust: "नियुक्ती बदला",
  cockpit_email_incoming_saving: "जतन करत आहे …",
  cockpit_email_incoming_unassigned: "नियुक्त नाही",
  cockpit_email_incoming_show_less: "कमी दाखवा",
  cockpit_email_incoming_show_all: "सर्व {{n}} दाखवा",
  cockpit_io_settings: "Kjuup.io सेटिंग्ज",
  cockpit_io_settings_sub: "प्लॅन आणि सीट्स, कर्मचारी नियुक्ती, बिलिंग आणि इनव्हॉइस.",
  products_coming_soon: "लवकरच येत आहे",
  cockpit_upsell_io_title: "तुमच्यासोबत विचार करणारे तुमचे ऑफिस",
  cockpit_upsell_io_text: "तुमची ईमेल खाती Kjuup शी जोडा. ईमेल्स, संलग्नके आणि संदेश योग्य प्रकल्पात आपोआप जतन होतात आणि हवे असल्यास तुमच्या सर्व्हरवर साठवता येतात. दररोज तुम्हाला सर्व प्रकल्पांचा सारांश आणि सर्व मजकुरातील मुख्य मुद्दे मिळतात, आणि तुमची कार्ये तुमच्या कॅलेंडर किंवा to-do अॅपशी सिंक होतात.",
  cockpit_upsell_io_soon_title: "अद्याप बुक करता येत नाही",
  cockpit_upsell_io_soon_text: "Kjuup.io लवकरच सुरू होत आहे. आता माहिती मागवा – Kjuup.io बुक करता येताच आम्ही तुम्हाला कळवू.",
  cockpit_upsell_io_planned_price: "नियोजित किंमत",
  cockpit_upsell_io_cta_request: "माहिती मागवा",
  kjuup_plus_abo_per_year: "/ वर्ष",
  kjuup_plus_abo_per_month: "/ महिना",
  kjuup_plus_abo_status_active: "सक्रिय",
  kjuup_plus_abo_status_requested: "रद्द करण्याची विनंती केली",
  kjuup_plus_abo_status_past_due: "पेमेंट देय",
  kjuup_plus_abo_eyebrow: "Kjuup+ · सबस्क्रिप्शन",
  kjuup_plus_abo_title: "Kjuup+ पॅकेज",
  kjuup_plus_abo_seats_free_one: "1 सीट शिल्लक",
  kjuup_plus_abo_billing: "बिलिंग",
  kjuup_plus_abo_yearly: "वार्षिक",
  kjuup_plus_abo_monthly: "मासिक",
  kjuup_plus_abo_amount: "रक्कम",
  kjuup_plus_abo_ends: "समाप्ती तारीख",
  kjuup_plus_abo_renews: "पुढील नूतनीकरण",
  kjuup_plus_abo_next_invoice: "पुढील इनव्हॉइस",
  kjuup_plus_abo_intro: "सुरुवातीची किंमत",
  kjuup_plus_abo_pending_tier: "पुढील नूतनीकरणापासून",
  kjuup_plus_abo_manual: "Kjuup+ तुमच्या कंपनीसाठी वैयक्तिक करारानुसार सक्रिय आहे.",
  kjuup_plus_abo_invoices: "इनव्हॉइस",
  kjuup_plus_abo_invoice_paid: "भरले",
  kjuup_plus_abo_invoice_view: "पहा",
  kjuup_plus_abo_invoices_less: "कमी दाखवा",
  kjuup_plus_abo_member_hint: "बिलिंग आणि रद्द करणे तुमच्या कंपनी प्रशासकांकडून व्यवस्थापित केले जाते.",
  kjuup_plus_abo_withdraw: "विनंती मागे घ्या",
  kjuup_plus_abo_cancel_note: "कारण (ऐच्छिक)",
  kjuup_plus_abo_cancel_send: "रद्द करण्याची विनंती करा",
  kjuup_plus_abo_cancel: "सबस्क्रिप्शन रद्द करा",
  cockpit_upsell_plus_f1: "तुमच्या सर्व कर्मचाऱ्यांच्या संवाद क्रियाकलापांचे व्यवस्थापन करा",
  cockpit_upsell_plus_f2: "कंपनीतील विशिष्ट वापरकर्ता गटांना माहिती द्या",
  cockpit_upsell_plus_f3: "अंतर्गत गट चॅट जतन करा",
  cockpit_upsell_plus_when_yearly: "वार्षिक पेमेंट केल्यास",
  cockpit_upsell_plus_size_small: "1–50 कर्मचारी",
  cockpit_upsell_plus_size_large: "51–200 कर्मचारी",
  cockpit_upsell_plus_title: "कंपन्यांसाठी Kjuup+",
  cockpit_upsell_plus_text: "कर्मचारी, लेखन परवानग्या आणि कंपनीचा संवाद एकाच ठिकाणी व्यवस्थापित करा. अंतर्गत चॅनेल तुमच्या टीमपुरते राहतात, बाह्य चॅनेल तुम्हाला प्रकल्प भागीदारांशी जोडतात आणि तुम्ही विशिष्ट गटांपर्यंत थेट पोहोचू शकता. Kjuup+ व्यतिरिक्त तुम्ही कर्मचारी गटांसाठी Kjuup.io अॅक्सेस बुक करू शकता. Kjuup+ आणि Kjuup.io एकत्र वापरता येतात.",
  cockpit_upsell_plus_size: "कंपनीचा आकार",
  cockpit_upsell_plus_billing: "बिलिंग",
  cockpit_upsell_plus_per_company: "/ कंपनी · महिना, जीएसटी/व्हॅट वगळून",
  cockpit_upsell_plus_onboarding: "ऑनबोर्डिंग/परिचय खर्च कंपनीच्या आकारावर अवलंबून असतो",
  cockpit_upsell_plus_larger: "मोठ्या कंपन्यांसाठी किंमत विनंतीनुसार",
  cockpit_upsell_plus_cta: "बंधनाशिवाय चौकशी करा",
  cockpit_kpi_deadlines_tasks: "अंतिम मुदती आणि कार्ये",
  cockpit_kpi_appointments: "भेटी",
  cockpit_room_admin: "प्रकल्प आणि चॅट व्यवस्थापन",
  cockpit_room_admin_sub: "सर्व कंपनी प्रकल्प सदस्य, मीडिया आणि चॅटसह.",
  pro_todo_not_found: "हे कार्य आता उपलब्ध नाही.",
  cockpit_chip_overdue: "मुदतीबाहेर",
  cockpit_chip_today: "आज",
  cockpit_calendar_week: "आठवडा {{week}}",
  cockpit_prev_week: "मागील आठवडा",
  cockpit_next_week: "पुढील आठवडा",
  cockpit_chip_requested: "विनंती केलेले",
  cockpit_todo_due: "अंतिम मुदत {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "{{name}} कडून",
  cockpit_todo_since: "{{when}} पासून",
  cockpit_todo_no_date: "तारीख नाही",
  cockpit_todo_mark_done: "पूर्ण म्हणून चिन्हांकित करा",
  cockpit_my_tasks_title: "माझी कार्ये",
  cockpit_today_tasks_group: "आजची कार्ये",
  cockpit_assign_none: "कोणालाही नियुक्त केलेले नाही",
  no_project_found: "प्रकल्प सापडला नाही",
  cockpit_row_more_actions: "अधिक क्रिया",
  needs_date: "तारीख नियुक्त करा",
  cockpit_assign_proposal: "{{name}} ओळखले – नियुक्त करायचे?",
  cockpit_assign_proposal_confirm: "नियुक्त करा",
  cockpit_assign_proposal_dismiss: "दुर्लक्ष करा",
  cockpit_priority_date: "तारीख",
  todo_calendar_add: "कॅलेंडरमध्ये जोडा",
  todo_calendar_remove: "कॅलेंडरमधून काढा",
  cockpit_todo_change_project: "प्रकल्प बदला",
  cockpit_todo_set_date: "तारीख सेट करा",
  pro_todo_done_confirm: "हे कार्य खरोखर पूर्ण म्हणून चिन्हांकित करायचे आहे का?",
  cockpit_task_delete_failed: "कार्य हटवता आले नाही.",
  cockpit_setup_title: "सेटअप पूर्ण करा",
  cockpit_setup_text: "तुम्हाला चॅट वापरायचे आहेत का आणि Kjuup.io ने ईमेल क्लायंट म्हणून काम करावे की फक्त प्रकल्प आणि दैनिक अहवालांसह, ते ठरवा.",
  cockpit_setup_cta: "आता सेट करा",
  cockpit_group_tasks: "अंतिम मुदती आणि कार्ये",
  cockpit_group_appointments: "भेटी",
  cockpit_report_no_activity: "गेल्या 24 तासांत या प्रकल्पात नवीन संदेश किंवा ईमेल्स नव्हते.",
  cockpit_report_room_unavailable: "हा प्रकल्प उपलब्ध नाही.",
  cockpit_report_create_failed: "दैनिक अहवाल तयार करता आला नाही.",
  cockpit_report_created: "दैनिक अहवाल तयार केला",
  addon_enable_confirm: "अॅड-ऑन सक्षम करायचे?",
  addon_enable: "सक्षम करा",
  addon_enabled: "अॅड-ऑन सक्षम केले",
  nav_email: "ईमेल",
  nav_my_cockpit: "माझे कॉकपिट",
  nav_news: "बातम्या",
  nav_recommend: "शिफारस करा",
  pro_todo_status_done: "पूर्ण",
  pro_todo_status_open: "खुले",
  v2_todo_remove: "काढा",
  pro_todo_search_people: "लोक शोधा",
  pro_todo_clear: "साफ करा",
  pro_todo_assigned: "(नियुक्त)",
  pro_todo_no_people: "कोणतेही लोक सापडले नाहीत",
  pro_todo_search_rooms: "प्रकल्प शोधा",
  pro_todo_no_rooms_match: "“{{q}}” शी जुळणारे प्रकल्प नाहीत",
  pro_todo_no_rooms: "कोणतेही प्रकल्प सापडले नाहीत",
  pro_todo_activity: "क्रियाकलाप",
  pro_todo_show_less: "कमी दाखवा",
  pro_todo_show_all: "सर्व दाखवा ({{n}})",
  pro_todo_due: "अंतिम मुदत",
  pro_todo_room: "प्रकल्प",
  pro_todo_select_room: "प्रकल्प निवडा",
  pro_todo_status: "स्थिती",
  pro_todo_more: "अधिक",
  pro_todo_edit_title: "कार्य संपादित करा",
  pro_todo_description: "वर्णन",
  pro_todo_created_by: "तयार करणारा",
  pro_todo_chat: "चॅट",
  navigate_to_source: "स्रोताकडे जा",
  todo_calendar_connect_title: "कोणतेही कॅलेंडर जोडलेले नाही",
  todo_calendar_connect_body_web: "ToDo जोडण्यासाठी कॅलेंडर सिंक सेटिंग्जमध्ये कॅलेंडर जोडा.",
  todo_calendar_connect: "जोडा",
  todo_calendar_removed: "तुमच्या कॅलेंडरमधून काढले",
  todo_calendar_added_later: "जोडले. तुमचे कॅलेंडर उपलब्ध झाले नाही; Kjuup नंतर पुन्हा प्रयत्न करेल.",
  todo_calendar_added: "तुमच्या कॅलेंडरमध्ये जोडले",
  todo_calendar_no_date: "फक्त तारीख असलेले ToDo कॅलेंडरमध्ये जोडता येते.",
  todo_calendar_failed: "तुमचे कॅलेंडर अपडेट करता आले नाही. कृपया पुन्हा प्रयत्न करा.",
  todo_calendar_date_title: "अद्याप तारीख नाही",
  todo_calendar_date_save: "तारीख सेट करा आणि जोडा",
  todo_calendar_date_body_web: "या बुकमार्क केलेल्या कार्याला अद्याप तारीख नाही. कॅलेंडरमध्ये जोडण्यासाठी तारीख सेट करा.",
  kjuup_io_setup_saved: "सेटअप जतन केला",
  kjuup_io_setup_step: "पायरी",
  kjuup_io_setup_chats_title: "तुम्हाला चॅट वापरायचे आहेत का?",
  kjuup_io_setup_email_title: "तुम्हाला तुमचे ईमेल्स कुठे वाचायचे आहेत?",
  kjuup_io_setup_chats_sub: "सहकारी आणि प्रकल्प भागीदारांसोबतचे चॅट ऐच्छिक आहेत. तुम्ही ते कॉकपिटवर केव्हाही दाखवू किंवा लपवू शकता.",
  kjuup_io_setup_email_sub: "यामुळे फक्त हे ठरते की तुम्ही Kjuup मध्ये ईमेल क्लायंट वापरणार की Outlook सारखा तुमचा सध्याचा ईमेल प्रोग्राम वापरत राहणार. तुम्ही नंतर बदलू शकता.",
  kjuup_io_setup_chats_yes: "होय, चॅट दाखवा",
  kjuup_io_setup_chats_yes_text: "संदेशांमध्ये चॅट आणि ईमेल्स असतात. प्रकल्पांमध्ये सर्व सहभागींसाठी गट चॅट असतात.",
  kjuup_io_setup_chats_no: "नाही, चॅटशिवाय काम करा",
  kjuup_io_setup_chats_no_text: "चॅट लपवले जातात. \"संदेश\" हे \"ईमेल\" बनते; प्रकल्प, कार्ये आणि दैनिक अहवाल राहतात.",
  kjuup_io_setup_email_client: "Kjuup मधील ईमेल क्लायंट",
  kjuup_io_setup_email_client_text: "Kjuup मध्येच ईमेल्स वाचा आणि उत्तर द्या.",
  kjuup_io_setup_email_reports: "सध्याचा ईमेल क्लायंट",
  kjuup_io_setup_email_reports_text: "Outlook किंवा इतर तुमच्या सध्याच्या प्रोग्राममध्ये वाचणे आणि उत्तर देणे सुरू ठेवा.",
  kjuup_io_setup_skip: "नंतर",
  next: "पुढे",
  kjuup_io_setup_finish: "सेटअप पूर्ण करा",
  today_label: "आज",
  tomorrow_label: "उद्या",
  cockpit_todo_overdue: "मुदतीबाहेर",
  cockpit_report_management_fazit: "व्यवस्थापन सारांश",
  cockpit_todo_appointment: "भेट",
  cockpit_todo_deadline: "अंतिम मुदत",
  cockpit_todo_deadline_define: "अंतिम मुदत निश्चित करा",
  pro_todo_status_acknowledged: "पुष्टी केली",
  pro_todo_responsible: "जबाबदार",
  pro_todo_notice_confirmed: "चॅटमध्ये पुष्टी केली",
  pro_todo_notice_sent_at: "संदेश पाठवला",
  pro_todo_notice_again: "संदेश पुन्हा पाठवा",
  pro_todo_notice_send: "Kjuup संदेशाद्वारे कळवा",
  pro_todo_add_assignee: "जोडा",
  pro_todo_edit: "संपादित करा",
  pro_todo_change_room: "प्रकल्प बदला",
  pro_todo_due_on: "अंतिम मुदत",
  pro_todo_edit_due: "अंतिम मुदत संपादित करा",
  pro_todo_no_date: "तारीख नाही",
  pro_todo_edit_description: "वर्णन संपादित करा",
  pro_todo_no_description: "अद्याप वर्णन नाही",
  pro_todo_title_label: "शीर्षक",
  pro_todo_title_placeholder: "शीर्षक लिहा...",
  pro_todo_task: "कार्य",
  pro_todo_what: "काय करायचे आहे?",
  pro_todo_source_email: "ई-मेल",
  pro_todo_sources: "स्रोत",
  previous: "मागील",
  kjuup_plus_abo_tier_large: "Kjuup+ Large ({max} कर्मचाऱ्यांपर्यंत)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small ({max} कर्मचाऱ्यांपर्यंत)",
  kjuup_plus_abo_status_ends: "{date} रोजी संपेल",
  kjuup_plus_abo_seats_over: "{max} पेक्षा जास्त कर्मचारी – Kjuup वैयक्तिक ऑफरसह तुमच्याशी संपर्क साधेल.",
  kjuup_plus_abo_seats_next: "आणखी कर्मचारी जोडले गेल्यास पॅकेज आपोआप {next} मध्ये बदलेल (प्रमाणानुसार शुल्क).",
  kjuup_plus_abo_seats_used: "{total} पैकी {used} सीट वापरात",
  kjuup_plus_abo_seats_free: "{count} सीट शिल्लक",
  kjuup_plus_abo_intro_until: "{date} पर्यंत",
  kjuup_plus_abo_invoice_open: "थकित · देय {date}",
  kjuup_plus_abo_invoices_all: "सर्व {count} दाखवा",
  kjuup_plus_abo_requested_hint: "{date} रोजी रद्द करण्याची विनंती केली. Kjuup मुदत संपल्यावर ({end}) याची पुष्टी करेल.",
  kjuup_plus_abo_cancel_hint: "Kjuup तुमच्या विनंतीचा आढावा घेईल आणि मुदत संपल्यावर ({end}) रद्द करण्याची पुष्टी करेल. तोपर्यंत Kjuup+ सक्रिय राहील.",
  kjuup_plus_abo_withdrawn: "रद्द करण्याची विनंती मागे घेतली",
  kjuup_plus_abo_requested: "रद्द करण्याची विनंती केली",
  cockpit_upsell_plus_intro_hint: "पहिले {months} महिने, नंतर {price}",
  cockpit_upsell_plus_badge: "{months} महिन्यांसाठी प्रारंभिक किंमत",
  calendar_syncing: "कॅलेंडरमधून अपडेट होत आहे…",
  calendar_sync_up_to_date: "कॅलेंडर अद्ययावत आहे",
  calendar_sync_failed: "सिंक अयशस्वी झाले",
  delete_multiple_tasks_confirm: "तुम्हाला खरोखर {count} ToDo हटवायचे आहेत का?",
  todos_deleted_count: "{count} ToDo हटवले",
  todos_deleted_partial: "{ok} ToDo हटवले, {fail} अयशस्वी",
  todo_unknown: "अज्ञात",
  todo_created_from_message: "या संदेशातून कार्य तयार केले",
  kjuup_io_todo_calendar_trial_ended_note: "कॅलेंडर सिंक · सदस्यता घ्या",
  kjuup_io_todo_calendar_nudge: "हे ToDo तुमच्या कॅलेंडरशी सिंक करायचे?",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.io सक्रिय करा",
  todo_confirmed: "ToDo पुष्टी केली",
  pro_todo_bulk_delete_title: "{{n}} कार्ये हटवायची?",
  pro_todo_previous_none_own: "ही थकित कार्ये तुम्हाला इतरांनी नेमून दिली आहेत आणि फक्त तेच ती हटवू शकतात.",
  pro_todo_previous_none: "कोणतीही थकित कार्ये नाहीत",
  pro_todo_previous_title: "{{n}} थकित कार्ये हटवायची?",
  pro_todo_previous_text: "मागील दिवसांची तुमची सर्व खुली कार्ये हटवली जातील.",
  pro_todo_previous_skipped: "इतरांनी नेमून दिलेली {{n}} कार्ये तशीच राहतील.",
  unassign_task_confirm: "या कार्यातून तुमची नियुक्ती रद्द करायची आहे का?",
  unassign_label: "रद्द करा",
  pro_todo_delete_title: "कार्य हटवा",
  pro_todo_today: "आज",
  pro_todo_yesterday: "काल",
  pro_todo_since_yesterday: "कालपासून",
  pro_todo_mark_open: "खुले म्हणून चिन्हांकित करा",
  verify_completion: "सत्यापित करा",
  new_label: "नवीन",
  bookmarked_no_mylist: "बुकमार्क केलेली कार्ये माझ्या यादीत जोडता येत नाहीत",
  delete_only_own: "तुम्ही फक्त स्वतः तयार केलेली कार्ये हटवू शकता",
  todo_clear_all: "सर्व साफ करा",
  pro_todo_of_completed: "{{total}} पैकी {{done}} पूर्ण",
  pro_todo_pick_date: "तारीख निवडा",
  pro_todo_show_day: "दिवस दाखवा",
  todo_adjust_list: "यादी समायोजित करा",
  pro_todo_section_upcoming: "आगामी",
  pro_todo_section_done: "पूर्ण",
  pro_todo_room_empty_today: "या प्रकल्पात आज कोणतीही कार्ये नाहीत",
  pro_todo_room_empty_day: "या प्रकल्पात या दिवशी कोणतीही कार्ये नाहीत",
  pro_todo_delete_previous: "सर्व हटवा",
  todo_my_list_empty: "तुमचा दिवस रिक्त आहे",
  todo_my_list_empty_hint: "कार्ये जोडण्यासाठी “यादी समायोजित करा” वर क्लिक करा",
  pro_todo_empty_title: "येथे काहीही नाही",
  pro_todo_empty_hint: "या दृश्याशी जुळणारी कोणतीही कार्ये नाहीत.",
  pro_todo_selected: "{{n}} निवडले",
  delete_selected_count: "हटवा ({count})",
  pro_todo_adjust_done: "झाले",
  pro_todo_deleting: "हटवत आहे...",
  pro_todo_reopen: "कार्य पुन्हा उघडा",
  pro_todo_step_done: "पूर्ण",
  move_back_in_progress: "पुन्हा प्रगतीपथावर हलवा",
  pro_todo_mark_not_started: "सुरू न केलेले म्हणून चिन्हांकित करा",
  back_into_in_progress: "पुन्हा प्रगतीपथावर",
  pro_todo_mark_in_progress: "प्रगतीपथावर म्हणून चिन्हांकित करा",
  unassign_todo: "ToDo नियुक्ती रद्द करा",
  pro_todo_open_room: "प्रकल्प उघडा",
  pro_todo_new_task: "नवीन कार्य",
  select_user_back_to_in_progress: "प्रगतीपथावर परत नेण्यासाठी वापरकर्ता निवडा",
  cockpit_email_accounts_n_many: "{{n}} खाती जोडली",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup संपर्क",
  combined_tab_teams: "Teams संपर्क",
  combined_bridge_failed: "Teams प्रत तयार करता आली नाही.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup आणि Teams संपर्क: Microsoft Teams मध्येही दिसणारा नवीन गट तयार केला जाईल.",
  teams_new_chat_title: "नवीन Teams चॅट",
  teams_new_chat_topic: "गटाचे नाव (ऐच्छिक)",
  teams_new_chat_start: "चॅट सुरू करा",
  teams_new_chat_creating: "चॅट तयार होत आहे…",
  teams_new_chat_forbidden: "Microsoft Teams या चॅटला परवानगी देत नाही (उदा. तुमच्या संस्थेबाहेरील व्यक्ती किंवा तुमच्या IT चे धोरण).",
  teams_new_chat_too_many: "एका चॅटसाठी खूप जास्त लोक.",
  teams_new_chat_type_hint: "तुमच्या संस्थेत शोधण्यासाठी नाव टाइप करा.",
  teams_new_chat_directory_forbidden: "तुमची संस्था निर्देशिकेत शोधण्याची परवानगी देत नाही. फक्त तुमच्या Teams चॅटमधील लोक दाखवले आहेत.",
  teams_new_chat_account: "खाते",
};
